
import {fontGfx, fontGfx16} from "./iwii"

// ImageWriter II Driver for Apple2TS - Copyright 2023 Michael Morrison <codebythepound@gmail.com>
/* ImageWriter fonts dumped from the roms */

/* NOTE, all fonts are of the following format.
  
   Fixed width  fonts have 156 glyphs
   Proportional fonts have 124 glyphs (they don't include the mousetext glyphs)
 
0123456780123456780123456780123456780123456780123456780123456780123456780123456780123456780123456780 52d0
* ****** *        *        *  ***   *   **   *  ***   * *   *  *  * *   *  ***   *    *   *  * *   *
**  *    *        **   *   * *   *  *  *  *  * *      *   *    *        *  * *   *   *    *        *
**  *    **** **  *****    * *  **  *  *     *  ***   *  * *   *  ***   *  ***   *  ***   *  ***   *
*******  *   *  * **  **   * * * *  * ****   * *   *  * *   *  * *   *  * *   *  * *   *  *     *  *  0x0A
**  *    * ****** *  * *   * **  *  *  *     *  ***   **     * * *   *  **     * * *****  *  ****  *
**  *    **  *    ***  *   * *   *  *  *     *     *  ******** * *   *  ******** * *      * *   *  *
**  **** * ** *** * ***    *  ***   * * ***  * ****   **     * *  ***   **     * *  ***   *  *** * *
*        *        **       *        *        *        *        *        *        *        *        *
0123456780123456780123456780123456780123456780123456780123456780123456780123456780123456780123456780 5328
*  ***   *  * *   *   ***  *  *     *  * *   *  ***   *  *     *   *    *    *   * **  *  * **  *  *
*  * *   *        *  *   * *   *    *        *        *   *    *        *        **  **   **  **   *
*  ***   * *   *  *  ****  *  ***   *        *     *  *  ***   *        *    *   * ****   * *   *  *
*     *  * *   *  *  *   * *     *  *        * *      * *   *  *   *    *  **    * *   *  * **  *  *  0x15
*  ****  * *   *  *  *   * *  ****  *        * ****   * *****  *   *    * *      * *   *  * * * *  *
* *   *  * *   *  *  ****  * *   *  *        * *  *   * *      *   *    * *    * * *   *  * *  **  *
*  *** * *  *** * * *      *  *** * *        *  ****  *  ***   *   *    *  ****  * *   *  * *   *  *
*        *        *        *        *        *  ***   *        *   *    * ****** *        *        *
0123456780123456780123456780123456780123456780123456780123456780123456780123456780123456780123456780 5380
*  ***   * *   *  *  * *   *  *     *  *     *  *     *        *   *    *  * *   *  *  *  *   *    *
*  * *   *  ***   *        *   *    *   *    *   *    *        *   *    *  * *   *  *  *  * *****  *
*  ***   * *   *  * *   *  * *   *  *  ***   *        *        *   *    *  * *   * ****** **  *    *
*        **     * * *   *  * *   *  * *   *  *  **    *        *   *    *        *  *  *  * *****  *
*        **     * * *   *  * *   *  * *   *  *   *    *        *        *        * ****** *   *  * *
*        * *   *  * *   *  * *   *  * *   *  *   *    *        *        *        *  *  *  * *****  *
*        *  ***   *  ***   *  *** * *  ***   *  ***   *        *   *    *        *  *  *  *   *    *
*        *        *        *        *        *        *        *        *        *        *        *
0123456780123456780123456780123456780123456780123456780123456780123456780123456780123456780123456780 53d8
***    * *  *     *    *   *    *   *  *     *        *        *        *        *        *      * *
***   *  * * *    *   *    *   *    *   *    *  *  *  *   *    *        *        *        *     *  *
*    *   * * *    *  *     *  *     *    *   *   **   *   *    *        *        *        *    *   *
*   *    * **   * *        *  *     *    *   * ****** * *****  *   **   * ****** *        *   *    *
*  *     **  * *  *        *  *     *    *   *   **   *   *    *   **   *        *        *  *     *
* *   ** **   *   *        *   *    *   *    *  *  *  *   *    *    *   *        *   **   * *      *
**    ** * *** ** *        *    *   *  *     *        *        *   *    *        *   **   **       *
*        *        *        *        *        *        *        *   **   *        *        *        *
0123456780123456780123456780123456780123456780123456780123456780123456780123456780123456780123456780 5430
*  ***   *   *    *  ****  *  ****  *    **  * ****** *     *  * ****** *  ****  *  ****  *        *
* *   *  *  **    * *    * * *    * *   * *  * *      *    *   *      * * *    * * *    * *        *
* *   *  *   *    *      * *      * *  *  *  * *****  *   *    *     *  * *    * * *    * *   **   *
* *   *  *   *    *    **  *   ***  * *   *  *      * *  ****  *    *   *  ****  *  ****  *   **   *
* *   *  *   *    *   *    *      * * ****** *      * * *    * *   *    * *    * *    *   *        *
* *   *  *   *    *  *     * *    * *     *  * *    * * *    * *  *     * *    * *   *    *   **   *
*  ***   *  ***   * ****** *  ****  *     *  *  ****  *  ****  *  *     *  ****  *  *     *   **   *
*        *        *        *        *        *        *        *        *        *        *        *
0123456780123456780123456780123456780123456780123456780123456780123456780123456780123456780123456780 5488
*   **   *     *  *        *  *     *  ****  *  ****  *   *    * *****  *  ****  * ****   * ****** *
*   **   *    *   *        *   *    * *    * * *    * *  * *   * *    * * *    * * *   *  * *      *
*        *   *    ******** *    *   *      * *      * * *   *  * *    * * *      * *    * * *      *
*   **   *  *     *        *     *  *    **  *   ** * **     * * *****  * *      * *    * * *****  *
*   **   *   *    ******** *    *   *   *    *  * * * ******** * *    * * *      * *    * * *      *
*    *   *    *   *        *   *    *        *  * * * **     * * *    * * *    * * *   *  * *      *
*   *    *     *  *        *  *     *   *    *  ****  **     * * *****  *  ****  * ****   * ****** *
*   **   *        *        *        *        *        *        *        *        *        *        *
0123456780123456780123456780123456780123456780123456780123456780123456780123456780123456780123456780 54e0
* ****** *  ****  * *    * *  ***   *    *** * *    * * *      **     * **     * *  ****  * *****  *
* *      * *    * * *    * *   *    *     *  * *   *  * *      ***   ** ***    * * *    * * *    * *
* *      * *      * *    * *   *    *     *  * *  *   * *      ** * * * ** *   * * *    * * *    * *
* *****  * *  *** * ****** *   *    *     *  * ***    * *      **  *  * **  *  * * *    * * *****  *
* *      * *    * * *    * *   *    * *   *  * *  *   * *      **     * **   * * * *    * * *      *
* *      * *    * * *    * *   *    * *   *  * *   *  * *      **     * **    ** * *    * * *      *
* *      *  ****  * *    * *  ***   *  ***   * *    * * ****** **     * **     * *  ****  * *      *
*        *        *        *        *        *        *        *        *        *        *        *
0123456780123456780123456780123456780123456780123456780123456780123456780123456780123456780123456780 5538
*  ****  * *****  *  ****  ******** * *    * **     * **     * **     * **     * * *****  *  ***   *
* *    * * *    * * *    * *   *    * *    * **     * **     * * *   *  * *   *  *     *  *  *     *
* *    * * *    * * *      *   *    * *    * **     * **     * *  * *   *  * *   *    *   *  *     *
* *    * * *****  *  ****  *   *    * *    * **     * **  *  * *   *    *   *    *   *    *  *     *
* *  * * * *  *   *      * *   *    * *    * * *   *  **  *  * *  * *   *   *    *  *     *  *     *
* *   *  * *   *  * *    * *   *    * *    * *  * *   ** * * * * *   *  *   *    * *      *  *     *
*  *** * * *    * *  ****  *   *    *  ****  *   *    * *   *  **     * *   *    * *****  *  ***   *
*        *        *        *        *        *        *        *        *        *        *        *
0123456780123456780123456780123456780123456780123456780123456780123456780123456780123456780123456780 5590
* *      *  ***   *   *    *        *  *     *        * *      *        *      * *        *    **  *
*  *     *    *   *  * *   *        *   *    *        * *      *        *      * *        *   *    *
*   *    *    *   *        *        *    *   *  ***   * *****  *  ****  *  ***** *  ***   *   *    *
*    *   *    *   *        *        *        *     *  * *    * * *      * *    * * *   *  * *****  *
*     *  *    *   *        *        *        *  ****  * *    * * *      * *    * * *****  *   *    *
*      * *    *   *        *        *        * *   *  * *    * * *      * *    * * *      *   *    *
*       **  ***   *        **********        *  *** * * *****  *  ****  *  ***** *  ***   *   *    *
*        *        *        **********        *        *        *        *        *        *        *
0123456780123456780123456780123456780123456780123456780123456780123456780123456780123456780123456780 55e8
*  ****  * *      *   *    *    *   * *      *  **    *        *        *        * *      *     *  *
*      * * *      *        *        * *   *  *   *    *        *        *        * *      *     *  *
*      * * ****   *   *    *    *   * *  *   *   *    *******  * ****   *  ****  * ****   *  ****  *
* *    * * *   *  *   *    *    *   * * *    *   *    **  *  * * *   *  * *    * * *   *  * *   *  *
* ****** * *   *  *   *    *    *   * ***    *   *    **  *  * * *   *  * *    * * *   *  * *   *  *
* *    * * *   *  *   *    *  ***   * *  *   *   *    **  *  * * *   *  * *    * * *   *  * *   *  *
*  ****  * *   *  *   *    * *  *   * *   *  *   *    **  *  * * *   *  *  ****  * ****   *  ****  *
*  ***** *        *        *  **    *        *        *        *        *        * *      *     *  *
0123456780123456780123456780123456780123456780123456780123456780123456780123456780123456780123456780 5640
*        *        *   *    *        *        *        *        * *      *        *    **  *   *    *
*        *        *   *    *        *        *        *        *        *        *   *    *   *    *
* ****   *  ****  *  ****  * *   *  * *   *  **     * * *   *  *      * * *****  *   *    *   *    *
* *   *  * *      *   *    * *   *  * *   *  **  *  * *  * *   *  *  *  *    *   *  *     *   *    *
* *      *  ****  *   *    * *   *  * *   *  **  *  * *   *    *   **   *   *    *   *    *   *    *
* *      *      * *   *    * *   *  *  * *   ** * * * *  * *   * * *    *  *     *   *    *   *    *
* *      *  ****  *    **  *  ****  *   *    * *   *  * *   *  *  *     * *****  *    **  *   *    *
*        *        *        *        *        *        *        * *      *        *        *        *
0123456780123456780123456780123456780123456780123456780123456780123456780123456780123456780123456780 5698
*  **    * **  *  *        *    *   *    *   *        ******** *        *        *      * **********
*    *   **  **   *        *   *    *   *    *        * *   *  *      * *      * *      * *        *
*    *   *        *        * ** **  * ** **  * *      *  * *   *     *  *     *  *      * **********
*     *  *        *        ******** **     * * **     *   *    **   *   **   *   *  *   * *        *
*    *   *        *        *******  **    *  * ***    *   *    * * *    * * *    * **   * **********
*    *   *        *        *******  **    *  * ****   *  * *   *  *     *  *     ******** *        *
*  **    *        *        * ****** * * *  * * ** **  * * * *  *  *     *  *     * **     *        *
*        *        *        * ** **  * ** **  * *    * ******** *        *        *  *     **********
0123456780123456780123456780123456780123456780123456780123456780123456780123456780123456780123456780 56f0
*   *    *        *   *    *   *    **********      * ******** ***  *  ***  *  ****      ***      **
*  *     *        *   *    *  ***   *        *      * ******** *   **   *   **   **   *  ***   *  **
* *      *        *   *    * * * *  *        *      * ******** *  ***   *   ***  *    *   *   ***  *
**********        *   *    **  *  * *        *  *   * ******** * ****** * ****** * ********  ***** *
* *      *        **  *  * *   *    *        * **   * ******** *  ***   *   ***  *  ***** * ********
*  *     *        * * * *  *   *    *        ******** ******** *   **   *   **   *   ***  *    *   *
*   *    *        *  ***   *   *    *        * **     ******** *    *   *   *    **   *  ***   *  **
*        * * * *  *   *    *   *    *        *  *     ******** ***** ******* ******      ***      **
0123456780123456780123456780123456780123456780123456780123456780123456780123456780123456780123456780 5748
*        **       *   *    * * * * ** * * * **        *        *       **   *    **********  * *   *
*        **       *    *   ** * * * ** * * * *   ******        *       **  ***   *        *  * *   *
*        **       *     *  * * * * ** * * * **  *    *******   *       ** *****  *        **** *** *
***********       ******** ** * * * ** * * * *  *     *     *  *       ********* *        *        *
*        **       *     *  * * * * ** * * * **  *     *     *  *       ** *****  *        **** *** *
*        **       *    *   ** * * * ** * * * *  *     *     *  *       **  ***   *        *  * *   *
*        **       *   *    * * * * ** * * * **  *************  *       **   *    *        *  * *   *
*        **********        ** * * * ** * * * *        *        *       **        **********        *
0123456780123456780 57a0
******** **       *                                                                                 
*      * **       *                                                                                 
*      * **       *                                                                                 
*  **  * **       *                                                                                 
*  **  * **       *                                                                                 
*      * **       *                                                                                 
*      * **       *                                                                                 
******** **       *                                                                                 

*****************************************************************************************************/

// offset=4b80; width=12; height=8 bytes; file=imagewriterii.bin
export const DraftFixedFontData = new Uint8Array([
0x7e,0x00,0x09,0x00,0x7f,0x00,0x49,0x00,0x41,0x00,0x00,0x00,0x20,0x04,0x50,0x04,
0x78,0x04,0x50,0x04,0x58,0x00,0x00,0x00,0xae,0x44,0x20,0x54,0x08,0x44,0x3a,0x00,
0x00,0x00,0x00,0x00,0x3e,0x00,0x61,0x10,0x49,0x04,0x43,0x00,0x3e,0x00,0x00,0x00,
0x48,0x00,0x3e,0x01,0x48,0x01,0x48,0x02,0x40,0x00,0x00,0x00,0x0a,0x55,0x00,0x55,
0x00,0x55,0x00,0x55,0x28,0x00,0x00,0x00,0x60,0x11,0x28,0x04,0x22,0x04,0x28,0x11,
0x60,0x00,0x00,0x00,0x00,0x38,0x45,0x00,0x44,0x00,0x45,0x38,0x00,0x00,0x00,0x00,
0x70,0x00,0x28,0x03,0x24,0x03,0x28,0x00,0x70,0x00,0x00,0x00,0x38,0x44,0x10,0x44,
0x12,0x45,0x10,0x44,0x18,0x00,0x00,0x00,0x20,0x50,0x05,0x50,0x04,0x50,0x05,0x38,
0x40,0x00,0x00,0x00,0x20,0x50,0x04,0x53,0x04,0x53,0x04,0x38,0x40,0x00,0x00,0x00,
0x3c,0x40,0x01,0x40,0x00,0x40,0x01,0x3c,0x40,0x00,0x00,0x00,0x40,0x3e,0x41,0x00,
0x49,0x00,0x49,0x36,0x00,0x00,0x00,0x00,0x20,0x50,0x04,0x51,0x06,0x50,0x04,0x38,
0x40,0x00,0x00,0x00,0x00,0x00,0x01,0x00,0x00,0x00,0x01,0x00,0x00,0x00,0x00,0x00,
0x38,0xd1,0x00,0xd1,0x00,0xf1,0x00,0x44,0x00,0x00,0x00,0x00,0x38,0x44,0x10,0x45,
0x12,0x44,0x10,0x44,0x18,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0xf9,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0xb0,0xc0,0x20,0xc0,0x14,0xc0,0x00,0xc0,0xa0,0x00,0x00,0x00,
0x02,0x79,0x00,0x09,0x00,0x0a,0x00,0x0a,0x71,0x00,0x00,0x00,0x7a,0x01,0x08,0x01,
0x10,0x02,0x20,0x02,0x79,0x00,0x00,0x00,0x00,0x00,0x00,0x03,0x00,0x03,0x00,0x00,
0x00,0x00,0x00,0x00,0x18,0x25,0x42,0x00,0x42,0x00,0x42,0x25,0x18,0x00,0x00,0x00,
0x3c,0x41,0x00,0x40,0x00,0x40,0x00,0x41,0x3c,0x00,0x00,0x00,0x3c,0x40,0x00,0x41,
0x02,0x40,0x00,0x3c,0x40,0x00,0x00,0x00,0x00,0x38,0x44,0x01,0x46,0x00,0x44,0x38,
0x00,0x00,0x00,0x00,0x00,0x00,0x48,0x01,0x7a,0x00,0x40,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x4f,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x07,0x00,0x00,0x00,0x07,0x00,
0x00,0x00,0x00,0x00,0x14,0x00,0x7f,0x00,0x14,0x00,0x7f,0x00,0x14,0x00,0x00,0x00,
0x24,0x00,0x2a,0x00,0x7f,0x00,0x2a,0x00,0x12,0x00,0x00,0x00,0x03,0x40,0x23,0x10,
0x08,0x64,0x02,0x61,0x00,0x00,0x00,0x00,0x32,0x05,0x48,0x05,0x52,0x00,0x20,0x10,
0x48,0x00,0x00,0x00,0x00,0x00,0x00,0x04,0x02,0x01,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x1c,0x22,0x41,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x41,0x22,
0x1c,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x08,0x00,0x2a,0x14,0x08,0x14,0x2a,0x00,
0x08,0x00,0x00,0x00,0x08,0x00,0x08,0x00,0x3e,0x00,0x08,0x00,0x08,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x60,0xc0,0xb8,0x00,0x00,0x00,0x00,0x00,0x08,0x00,0x08,0x00,
0x08,0x00,0x08,0x00,0x08,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x60,0x00,0x60,0x00,
0x00,0x00,0x00,0x00,0x00,0x40,0x20,0x10,0x08,0x04,0x02,0x01,0x00,0x00,0x00,0x00,
0x1c,0x22,0x00,0x41,0x00,0x41,0x00,0x22,0x1c,0x00,0x00,0x00,0x00,0x00,0x42,0x00,
0x7f,0x00,0x40,0x00,0x00,0x00,0x00,0x00,0x42,0x01,0x60,0x01,0x50,0x01,0x48,0x01,
0x46,0x00,0x00,0x00,0x22,0x41,0x00,0x41,0x00,0x49,0x00,0x49,0x36,0x00,0x00,0x00,
0x10,0x08,0x14,0x02,0x11,0x00,0x7f,0x00,0x10,0x00,0x00,0x00,0x27,0x00,0x45,0x00,
0x45,0x00,0x45,0x00,0x39,0x00,0x00,0x00,0x30,0x48,0x04,0x4a,0x01,0x48,0x00,0x48,
0x30,0x00,0x00,0x00,0x01,0x00,0x01,0x00,0x61,0x10,0x09,0x04,0x03,0x00,0x00,0x00,
0x36,0x49,0x00,0x49,0x00,0x49,0x00,0x49,0x36,0x00,0x00,0x00,0x06,0x09,0x00,0x09,
0x40,0x29,0x10,0x09,0x06,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x6c,0x00,0x6c,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0xdb,0x00,0xbb,0x00,0x00,0x00,0x00,0x00,
0x00,0x08,0x00,0x14,0x00,0x22,0x00,0x41,0x00,0x00,0x00,0x00,0x14,0x00,0x14,0x00,
0x14,0x00,0x14,0x00,0x14,0x00,0x00,0x00,0x00,0x00,0x41,0x00,0x22,0x00,0x14,0x00,
0x08,0x00,0x00,0x00,0x02,0x01,0x00,0x01,0x50,0x01,0x08,0x01,0x06,0x00,0x00,0x00,
0x1c,0x22,0x41,0x08,0x55,0x00,0x55,0x00,0x0e,0x00,0x00,0x00,0x78,0x04,0x12,0x01,
0x10,0x01,0x12,0x04,0x78,0x00,0x00,0x00,0x41,0x3e,0x41,0x08,0x41,0x08,0x41,0x08,
0x36,0x00,0x00,0x00,0x3e,0x41,0x00,0x41,0x00,0x41,0x00,0x41,0x22,0x00,0x00,0x00,
0x41,0x3e,0x41,0x00,0x41,0x00,0x41,0x00,0x3e,0x00,0x00,0x00,0x7f,0x00,0x49,0x00,
0x49,0x00,0x49,0x00,0x41,0x00,0x00,0x00,0x7f,0x00,0x09,0x00,0x09,0x00,0x09,0x00,
0x01,0x00,0x00,0x00,0x3e,0x41,0x00,0x41,0x08,0x41,0x08,0x41,0x3a,0x00,0x00,0x00,
0x7f,0x00,0x08,0x00,0x08,0x00,0x08,0x00,0x7f,0x00,0x00,0x00,0x00,0x00,0x41,0x00,
0x7f,0x00,0x41,0x00,0x00,0x00,0x00,0x00,0x20,0x00,0x40,0x00,0x41,0x00,0x41,0x3e,
0x01,0x00,0x00,0x00,0x7f,0x00,0x08,0x00,0x14,0x00,0x22,0x00,0x41,0x00,0x00,0x00,
0x7f,0x00,0x40,0x00,0x40,0x00,0x40,0x00,0x40,0x00,0x00,0x00,0x7f,0x00,0x02,0x04,
0x08,0x04,0x02,0x00,0x7f,0x00,0x00,0x00,0x7f,0x00,0x02,0x04,0x08,0x10,0x20,0x00,
0x7f,0x00,0x00,0x00,0x3e,0x41,0x00,0x41,0x00,0x41,0x00,0x41,0x3e,0x00,0x00,0x00,
0x7f,0x00,0x09,0x00,0x09,0x00,0x09,0x00,0x06,0x00,0x00,0x00,0x3e,0x41,0x00,0x41,
0x10,0x41,0x20,0x01,0x5e,0x00,0x00,0x00,0x7f,0x00,0x09,0x00,0x09,0x00,0x19,0x20,
0x46,0x00,0x00,0x00,0x26,0x49,0x00,0x49,0x00,0x49,0x00,0x49,0x32,0x00,0x00,0x00,
0x01,0x00,0x01,0x00,0x7f,0x00,0x01,0x00,0x01,0x00,0x00,0x00,0x3f,0x40,0x00,0x40,
0x00,0x40,0x00,0x40,0x3f,0x00,0x00,0x00,0x07,0x08,0x10,0x20,0x40,0x20,0x10,0x08,
0x07,0x00,0x00,0x00,0x3f,0x40,0x20,0x10,0x0c,0x10,0x20,0x40,0x3f,0x00,0x00,0x00,
0x00,0x41,0x22,0x14,0x08,0x14,0x22,0x41,0x00,0x00,0x00,0x00,0x00,0x01,0x02,0x04,
0x78,0x04,0x02,0x01,0x00,0x00,0x00,0x00,0x00,0x41,0x20,0x51,0x08,0x45,0x02,0x41,
0x00,0x00,0x00,0x00,0x00,0x00,0x7f,0x00,0x41,0x00,0x41,0x00,0x00,0x00,0x00,0x00,
0x00,0x01,0x02,0x04,0x08,0x10,0x20,0x40,0x00,0x00,0x00,0x00,0x00,0x00,0x41,0x00,
0x41,0x00,0x7f,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x02,0x00,0x01,0x00,0x02,0x00,
0x00,0x00,0x00,0x00,0xc0,0x00,0xc0,0x00,0xc0,0x00,0xc0,0x00,0xc0,0x00,0xc0,0x00,
0x00,0x00,0x00,0x01,0x02,0x04,0x00,0x00,0x00,0x00,0x00,0x00,0x20,0x50,0x04,0x50,
0x04,0x50,0x04,0x38,0x40,0x00,0x00,0x00,0x7f,0x00,0x44,0x00,0x44,0x00,0x44,0x38,
0x00,0x00,0x00,0x00,0x38,0x44,0x00,0x44,0x00,0x44,0x00,0x44,0x00,0x00,0x00,0x00,
0x38,0x44,0x00,0x44,0x00,0x44,0x00,0x7f,0x00,0x00,0x00,0x00,0x38,0x44,0x10,0x44,
0x10,0x44,0x10,0x44,0x18,0x00,0x00,0x00,0x08,0x00,0x08,0x76,0x09,0x00,0x09,0x00,
0x00,0x00,0x00,0x00,0x18,0x24,0xa0,0x24,0xa0,0x24,0xa0,0x7c,0x00,0x00,0x00,0x00,
0x7f,0x00,0x04,0x00,0x04,0x00,0x04,0x78,0x00,0x00,0x00,0x00,0x00,0x00,0x44,0x00,
0x7d,0x00,0x40,0x00,0x00,0x00,0x00,0x00,0x40,0xa0,0x00,0xa0,0x04,0xa0,0x7d,0x00,
0x00,0x00,0x00,0x00,0x7f,0x00,0x10,0x00,0x28,0x00,0x44,0x00,0x00,0x00,0x00,0x00,
0x00,0x01,0x00,0x7f,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x78,0x04,0x00,0x04,
0x78,0x04,0x00,0x04,0x78,0x00,0x00,0x00,0x7c,0x00,0x04,0x00,0x04,0x00,0x04,0x78,
0x00,0x00,0x00,0x00,0x38,0x44,0x00,0x44,0x00,0x44,0x00,0x44,0x38,0x00,0x00,0x00,
0xff,0x00,0x44,0x00,0x44,0x00,0x44,0x38,0x00,0x00,0x00,0x00,0x38,0x44,0x00,0x44,
0x00,0x44,0x00,0xff,0x00,0x00,0x00,0x00,0x7c,0x00,0x08,0x04,0x00,0x04,0x00,0x04,
0x08,0x00,0x00,0x00,0x08,0x54,0x00,0x54,0x00,0x54,0x00,0x54,0x20,0x00,0x00,0x00,
0x04,0x00,0x3f,0x40,0x04,0x40,0x04,0x40,0x00,0x00,0x00,0x00,0x3c,0x40,0x00,0x40,
0x00,0x40,0x00,0x3c,0x40,0x00,0x00,0x00,0x04,0x08,0x10,0x20,0x40,0x20,0x10,0x08,
0x04,0x00,0x00,0x00,0x3c,0x40,0x20,0x10,0x08,0x10,0x20,0x40,0x3c,0x00,0x00,0x00,
0x44,0x28,0x00,0x10,0x00,0x28,0x44,0x00,0x00,0x00,0x00,0x00,0x04,0x08,0xc4,0xa8,
0x40,0x20,0x10,0x08,0x04,0x00,0x00,0x00,0x44,0x20,0x44,0x10,0x44,0x08,0x44,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x08,0x36,0x41,0x00,0x41,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x7f,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x41,0x00,
0x41,0x36,0x08,0x00,0x00,0x00,0x00,0x00,0x02,0x01,0x00,0x01,0x00,0x02,0x00,0x02,
0x01,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x38,0x84,0x78,0x84,0x78,0x02,0x79,0x84,0x78,0x84,0x48,0x00,0x38,0x84,0x00,0xc4,
0x00,0x42,0x01,0xc4,0x00,0xb4,0x48,0x00,0x00,0x00,0x00,0xf4,0x08,0x50,0x20,0x40,
0x80,0x00,0x00,0x00,0x00,0x00,0x81,0x42,0xa5,0x58,0xa5,0x42,0x81,0x00,0x00,0x00,
0x00,0x00,0x08,0x10,0x60,0x10,0x08,0x04,0x02,0x00,0x00,0x00,0x00,0x00,0x08,0x10,
0x60,0x10,0x08,0x04,0x02,0x00,0x00,0x00,0x00,0x20,0x50,0xa8,0x00,0x20,0x00,0x20,
0x00,0x3f,0x00,0x00,0x95,0x00,0x95,0x00,0x95,0x00,0x95,0x00,0x95,0x00,0x95,0x00,
0x08,0x14,0x2a,0x41,0x08,0x00,0x08,0x00,0x08,0x00,0x08,0x00,0x00,0x80,0x00,0x00,
0x00,0x80,0x00,0x00,0x00,0x80,0x00,0x00,0x00,0x00,0x10,0x20,0x40,0xbf,0x40,0x20,
0x10,0x00,0x00,0x00,0x00,0x00,0x08,0x04,0x02,0xfd,0x02,0x04,0x08,0x00,0x00,0x00,
0x01,0x00,0x01,0x00,0x01,0x00,0x01,0x00,0x01,0x00,0x01,0x00,0x00,0x20,0x50,0xa8,
0x00,0x20,0x00,0x20,0x00,0x3f,0x00,0x00,0xff,0x00,0xff,0x00,0xff,0x00,0xff,0x00,
0xff,0x00,0x00,0x00,0x81,0x00,0x89,0x14,0x2a,0x55,0x08,0x00,0x89,0x00,0x89,0x00,
0x89,0x00,0x89,0x00,0x08,0x55,0x2a,0x14,0x89,0x00,0x81,0x00,0xc3,0x00,0x08,0x10,
0x28,0x56,0x28,0x10,0x08,0x00,0xc3,0x00,0xc3,0x00,0x10,0x08,0x14,0x6a,0x14,0x08,
0x10,0x00,0xc3,0x00,0x08,0x00,0x08,0x00,0x08,0x00,0x08,0x00,0x08,0x00,0x08,0x00,
0xff,0x00,0x80,0x00,0x80,0x00,0x80,0x00,0x80,0x00,0x80,0x00,0x08,0x00,0x08,0x00,
0x08,0x00,0x08,0x41,0x2a,0x14,0x08,0x00,0x55,0xaa,0x00,0x55,0xaa,0x00,0x55,0xaa,
0x00,0x55,0xaa,0x00,0x55,0xaa,0x00,0x55,0xaa,0x00,0x55,0xaa,0x00,0x55,0xaa,0x00,
0x00,0x3c,0x42,0x00,0x42,0x00,0x42,0x00,0x46,0x00,0x44,0x00,0x44,0x00,0x44,0x00,
0x44,0x00,0x7c,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0xff,0x00,0x00,0x00,0x08,0x14,0x2a,0x55,0x2a,0x14,0x08,0x00,0x00,0x00,
0x81,0x00,0x81,0x00,0x81,0x00,0x81,0x00,0x81,0x00,0x81,0x00,0x00,0x00,0x14,0x00,
0x77,0x00,0x77,0x00,0x14,0x00,0x00,0x00,0x81,0x00,0x81,0x08,0x91,0x00,0x81,0x00,
0xff,0x00,0x00,0x00,0xff,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
])

//offset=52d0; width=8; height=8 bytes; file=imagewriterii.bin
export const CorrespondenceFixedFontData = new Uint8Array([
0x7e,0x09,0x09,0x7f,0x49,0x49,0x41,0x00,0x24,0x54,0x54,0x38,0x54,0x54,0x58,0x00,
0xae,0x64,0x54,0x4c,0x3a,0x00,0x00,0x00,0x00,0x3e,0x51,0x49,0x45,0x3e,0x00,0x00,
0x00,0x48,0x3e,0x49,0x49,0x42,0x00,0x00,0x00,0x4a,0x55,0x55,0x55,0x28,0x00,0x00,
0x70,0x29,0x24,0x22,0x24,0x29,0x70,0x00,0x00,0x38,0x45,0x44,0x45,0x38,0x00,0x00,
0x70,0x28,0x27,0x25,0x27,0x28,0x70,0x00,0x00,0x38,0x54,0x56,0x55,0x18,0x00,0x00,
0x00,0x20,0x55,0x54,0x55,0x38,0x40,0x00,0x00,0x20,0x57,0x55,0x57,0x38,0x40,0x00,
0x00,0x3c,0x41,0x40,0x41,0x3c,0x40,0x00,0x00,0x40,0x3e,0x25,0x25,0x25,0x1a,0x00,
0x00,0x20,0x55,0x56,0x54,0x38,0x40,0x00,0x00,0x00,0x01,0x00,0x01,0x00,0x00,0x00,
0x00,0x38,0xd1,0xd1,0xf1,0x44,0x00,0x00,0x00,0x38,0x55,0x56,0x54,0x18,0x00,0x00,
0x00,0x00,0x00,0xf9,0x00,0x00,0x00,0x00,0x00,0xb0,0xc8,0xc8,0xc5,0xc0,0xa0,0x00,
0x02,0x7d,0x05,0x06,0x06,0x79,0x00,0x00,0x02,0x7d,0x09,0x12,0x22,0x7d,0x00,0x00,
0x00,0x00,0x07,0x05,0x07,0x00,0x00,0x00,0x18,0x25,0x42,0x42,0x42,0x25,0x18,0x00,
0x00,0x3c,0x41,0x40,0x41,0x3c,0x00,0x00,0x00,0x3c,0x41,0x42,0x40,0x3c,0x40,0x00,
0x00,0x38,0x45,0x46,0x44,0x38,0x00,0x00,0x00,0x00,0x49,0x7a,0x40,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x4f,0x00,0x00,0x00,0x00,
0x00,0x00,0x07,0x00,0x07,0x00,0x00,0x00,0x00,0x14,0x7f,0x14,0x14,0x7f,0x14,0x00,
0x04,0x2a,0x2a,0x7f,0x2a,0x2a,0x10,0x00,0x43,0x23,0x10,0x08,0x04,0x62,0x61,0x00,
0x30,0x4e,0x49,0x56,0x20,0x50,0x48,0x00,0x00,0x00,0x04,0x02,0x01,0x00,0x00,0x00,
0x00,0x00,0x1c,0x22,0x41,0x00,0x00,0x00,0x00,0x00,0x41,0x22,0x1c,0x00,0x00,0x00,
0x00,0x08,0x2a,0x1c,0x1c,0x2a,0x08,0x00,0x00,0x08,0x08,0x3e,0x08,0x08,0x00,0x00,
0x00,0x00,0x00,0xd8,0xb8,0x00,0x00,0x00,0x00,0x08,0x08,0x08,0x08,0x08,0x08,0x00,
0x00,0x00,0x00,0x60,0x60,0x00,0x00,0x00,0x40,0x20,0x10,0x08,0x04,0x02,0x01,0x00,
0x00,0x3e,0x41,0x41,0x41,0x3e,0x00,0x00,0x00,0x00,0x42,0x7f,0x40,0x00,0x00,0x00,
0x00,0x42,0x61,0x51,0x49,0x49,0x46,0x00,0x00,0x22,0x41,0x49,0x49,0x49,0x36,0x00,
0x00,0x18,0x14,0x12,0x11,0x7f,0x10,0x00,0x00,0x27,0x45,0x45,0x45,0x45,0x39,0x00,
0x00,0x30,0x48,0x4c,0x4a,0x49,0x30,0x00,0x00,0x01,0x61,0x11,0x09,0x05,0x03,0x00,
0x00,0x36,0x49,0x49,0x49,0x49,0x36,0x00,0x00,0x06,0x49,0x29,0x19,0x09,0x06,0x00,
0x00,0x00,0x00,0x6c,0x6c,0x00,0x00,0x00,0x00,0x00,0x00,0xdb,0xbb,0x00,0x00,0x00,
0x00,0x00,0x08,0x14,0x22,0x41,0x00,0x00,0x14,0x14,0x14,0x14,0x14,0x14,0x14,0x00,
0x00,0x00,0x41,0x22,0x14,0x08,0x00,0x00,0x00,0x02,0x01,0x51,0x09,0x09,0x06,0x00,
0x00,0x02,0x71,0x49,0x79,0x41,0x3e,0x00,0x78,0x14,0x12,0x11,0x12,0x14,0x78,0x00,
0x00,0x7f,0x49,0x49,0x49,0x49,0x36,0x00,0x00,0x3e,0x41,0x41,0x41,0x41,0x22,0x00,
0x00,0x7f,0x41,0x41,0x41,0x22,0x1c,0x00,0x00,0x7f,0x49,0x49,0x49,0x49,0x41,0x00,
0x00,0x7f,0x09,0x09,0x09,0x09,0x01,0x00,0x00,0x3e,0x41,0x41,0x49,0x49,0x3a,0x00,
0x00,0x7f,0x08,0x08,0x08,0x08,0x7f,0x00,0x00,0x00,0x41,0x7f,0x41,0x00,0x00,0x00,
0x00,0x30,0x40,0x40,0x41,0x3f,0x01,0x00,0x00,0x7f,0x08,0x08,0x14,0x22,0x41,0x00,
0x00,0x7f,0x40,0x40,0x40,0x40,0x40,0x00,0x7f,0x02,0x04,0x08,0x04,0x02,0x7f,0x00,
0x7f,0x02,0x04,0x08,0x10,0x20,0x7f,0x00,0x00,0x3e,0x41,0x41,0x41,0x41,0x3e,0x00,
0x00,0x7f,0x09,0x09,0x09,0x09,0x06,0x00,0x00,0x3e,0x41,0x41,0x51,0x21,0x5e,0x00,
0x00,0x7f,0x09,0x09,0x19,0x29,0x46,0x00,0x00,0x26,0x49,0x49,0x49,0x49,0x32,0x00,
0x01,0x01,0x01,0x7f,0x01,0x01,0x01,0x00,0x00,0x3f,0x40,0x40,0x40,0x40,0x3f,0x00,
0x0f,0x10,0x20,0x40,0x20,0x10,0x0f,0x00,0x3f,0x40,0x20,0x18,0x20,0x40,0x3f,0x00,
0x41,0x22,0x14,0x08,0x14,0x22,0x41,0x00,0x01,0x02,0x04,0x78,0x04,0x02,0x01,0x00,
0x00,0x61,0x51,0x49,0x45,0x43,0x00,0x00,0x00,0x00,0x7f,0x41,0x41,0x00,0x00,0x00,
0x00,0x01,0x02,0x04,0x08,0x10,0x20,0x40,0x00,0x00,0x41,0x41,0x7f,0x00,0x00,0x00,
0x00,0x00,0x02,0x01,0x02,0x00,0x00,0x00,0xc0,0xc0,0xc0,0xc0,0xc0,0xc0,0xc0,0xc0,
0x00,0x00,0x01,0x02,0x04,0x00,0x00,0x00,0x00,0x20,0x54,0x54,0x54,0x38,0x40,0x00,
0x00,0x7f,0x44,0x44,0x44,0x44,0x38,0x00,0x00,0x38,0x44,0x44,0x44,0x44,0x00,0x00,
0x00,0x38,0x44,0x44,0x44,0x44,0x7f,0x00,0x00,0x38,0x54,0x54,0x54,0x18,0x00,0x00,
0x00,0x08,0x08,0x7e,0x09,0x09,0x00,0x00,0x00,0x38,0xd1,0xd1,0xd1,0xd1,0xbe,0x00,
0x00,0x7f,0x04,0x04,0x04,0x78,0x00,0x00,0x00,0x00,0x00,0x7d,0x00,0x00,0x00,0x00,
0x00,0x40,0xa0,0xa0,0x7d,0x00,0x00,0x00,0x00,0x7f,0x10,0x18,0x24,0x42,0x00,0x00,
0x00,0x00,0x01,0x7f,0x00,0x00,0x00,0x00,0x7c,0x04,0x04,0x7c,0x04,0x04,0x78,0x00,
0x00,0x7c,0x04,0x04,0x04,0x78,0x00,0x00,0x00,0x38,0x44,0x44,0x44,0x44,0x38,0x00,
0x00,0xff,0x44,0x44,0x44,0x38,0x00,0x00,0x00,0x38,0x44,0x44,0x44,0xff,0x00,0x00,
0x00,0x7c,0x04,0x04,0x04,0x08,0x00,0x00,0x00,0x08,0x54,0x54,0x54,0x54,0x20,0x00,
0x00,0x00,0x04,0x3f,0x44,0x44,0x00,0x00,0x00,0x3c,0x40,0x40,0x40,0x7c,0x00,0x00,
0x00,0x1c,0x20,0x40,0x20,0x1c,0x00,0x00,0x3c,0x40,0x20,0x18,0x20,0x40,0x3c,0x00,
0x00,0x44,0x28,0x10,0x28,0x44,0x00,0x00,0x00,0xa1,0x48,0x30,0x10,0x08,0x04,0x00,
0x00,0x44,0x64,0x54,0x4c,0x44,0x00,0x00,0x00,0x00,0x08,0x36,0x41,0x41,0x00,0x00,
0x00,0x00,0x00,0x7f,0x00,0x00,0x00,0x00,0x00,0x00,0x41,0x41,0x36,0x08,0x00,0x00,
0x02,0x01,0x01,0x02,0x02,0x01,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x38,0xfc,0xfc,0x7a,0xfd,0xfc,0x48,0x00,0x38,0xc4,0x84,0x42,0x85,0xb4,0x48,0x00,
0x00,0xfc,0x78,0x30,0x60,0x40,0x80,0x00,0x81,0xc3,0xa5,0xd9,0xa5,0xc3,0x81,0x00,
0x08,0x10,0x60,0x10,0x08,0x04,0x02,0x00,0x08,0x10,0x60,0x10,0x08,0x04,0x02,0x00,
0x20,0x70,0xf8,0x20,0x20,0x20,0x3f,0x00,0x95,0x95,0x95,0x95,0x95,0x95,0x95,0x95,
0x08,0x1c,0x2a,0x49,0x08,0x08,0x08,0x08,0x00,0x80,0x00,0x80,0x00,0x80,0x00,0x00,
0x10,0x20,0x40,0xff,0x40,0x20,0x10,0x00,0x08,0x04,0x02,0xff,0x02,0x04,0x08,0x00,
0x01,0x01,0x01,0x01,0x01,0x01,0x01,0x01,0x20,0x70,0xf8,0x20,0x20,0x20,0x3f,0x00,
0xff,0xff,0xff,0xff,0xff,0xff,0xff,0x00,0x81,0x89,0x9c,0xbe,0x7f,0x88,0x88,0x81,
0x81,0x88,0x88,0x7f,0xbe,0x9c,0x89,0x81,0xc3,0x08,0x18,0x38,0x7e,0x38,0x18,0xcb,
0xc3,0x10,0x18,0x1c,0x7e,0x1c,0x18,0xd3,0x08,0x08,0x08,0x08,0x08,0x08,0x08,0x08,
0xff,0x80,0x80,0x80,0x80,0x80,0x80,0x80,0x08,0x08,0x08,0x49,0x2a,0x1c,0x08,0x00,
0xaa,0x55,0xaa,0x55,0xaa,0x55,0xaa,0x55,0xaa,0x55,0xaa,0x55,0xaa,0x55,0xaa,0x55,
0x00,0x00,0x7c,0x42,0x42,0x42,0x42,0x46,0x44,0x44,0x44,0x44,0x44,0x78,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0xff,0x08,0x1c,0x3e,0x7f,0x3e,0x1c,0x08,0x00,
0x81,0x81,0x81,0x81,0x81,0x81,0x81,0x81,0x14,0x14,0x77,0x00,0x77,0x14,0x14,0x00,
0x81,0x81,0x99,0x99,0x81,0x81,0xff,0x00,0xff,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
])

export const CorrespondencePropTable = [
{"width":18, "offset":0},
{"width":16, "offset":20},
{"width":11, "offset":40},
{"width":12, "offset":55},
{"width":13, "offset":67},
{"width":12, "offset":80},
{"width":16, "offset":92},
{"width":12, "offset":108},
{"width":16, "offset":120},
{"width":12, "offset":136},
{"width":12, "offset":148},
{"width":12, "offset":160},
{"width":12, "offset":172},
{"width":14, "offset":184},
{"width":12, "offset":198},
{"width":13, "offset":210},
{"width":10, "offset":223},
{"width":12, "offset":233},
{"width":7, "offset":245},
{"width":12, "offset":252},
{"width":12, "offset":264},
{"width":16, "offset":276},
{"width":13, "offset":292},
{"width":15, "offset":305},
{"width":15, "offset":320},
{"width":12, "offset":335},
{"width":12, "offset":347},
{"width":8, "offset":359},
{"width":7, "offset":367},
{"width":7, "offset":374},
{"width":10, "offset":381},
{"width":14, "offset":391},
{"width":12, "offset":405},
{"width":16, "offset":417},
{"width":13, "offset":433},
{"width":7, "offset":446},
{"width":7, "offset":453},
{"width":7, "offset":460},
{"width":12, "offset":467},
{"width":12, "offset":479},
{"width":7, "offset":491},
{"width":12, "offset":498},
{"width":7, "offset":510},
{"width":12, "offset":517},
{"width":12, "offset":529},
{"width":12, "offset":541},
{"width":12, "offset":553},
{"width":12, "offset":565},
{"width":12, "offset":577},
{"width":12, "offset":589},
{"width":12, "offset":601},
{"width":12, "offset":613},
{"width":12, "offset":625},
{"width":12, "offset":637},
{"width":7, "offset":649},
{"width":7, "offset":656},
{"width":12, "offset":663},
{"width":12, "offset":675},
{"width":12, "offset":687},
{"width":12, "offset":699},
{"width":14, "offset":711},
{"width":16, "offset":725},
{"width":15, "offset":741},
{"width":14, "offset":756},
{"width":15, "offset":770},
{"width":15, "offset":785},
{"width":15, "offset":800},
{"width":14, "offset":815},
{"width":15, "offset":829},
{"width":9, "offset":844},
{"width":13, "offset":853},
{"width":12, "offset":866},
{"width":13, "offset":878},
{"width":17, "offset":891},
{"width":16, "offset":908},
{"width":15, "offset":924},
{"width":13, "offset":939},
{"width":16, "offset":952},
{"width":15, "offset":968},
{"width":12, "offset":983},
{"width":14, "offset":995},
{"width":15, "offset":1009},
{"width":16, "offset":1024},
{"width":17, "offset":1040},
{"width":11, "offset":1057},
{"width":14, "offset":1068},
{"width":11, "offset":1082},
{"width":12, "offset":1093},
{"width":12, "offset":1105},
{"width":12, "offset":1117},
{"width":12, "offset":1129},
{"width":17, "offset":1141},
{"width":7, "offset":1158},
{"width":12, "offset":1165},
{"width":12, "offset":1177},
{"width":10, "offset":1189},
{"width":12, "offset":1199},
{"width":12, "offset":1211},
{"width":10, "offset":1223},
{"width":12, "offset":1233},
{"width":12, "offset":1245},
{"width":8, "offset":1257},
{"width":7, "offset":1265},
{"width":10, "offset":1272},
{"width":8, "offset":1282},
{"width":16, "offset":1290},
{"width":12, "offset":1306},
{"width":12, "offset":1318},
{"width":12, "offset":1330},
{"width":12, "offset":1342},
{"width":10, "offset":1354},
{"width":12, "offset":1364},
{"width":10, "offset":1376},
{"width":12, "offset":1386},
{"width":12, "offset":1398},
{"width":16, "offset":1410},
{"width":12, "offset":1426},
{"width":12, "offset":1438},
{"width":10, "offset":1450},
{"width":10, "offset":1460},
{"width":7, "offset":1470},
{"width":10, "offset":1477},
{"width":13, "offset":1487},
{"width":7, "offset":1500},
]

//offset=5924; width=v; height=8 bytes; file=imagewriterii.bin
export const CorrespondencePropFontData = new Uint8Array([
0x00,0x78,0x0c,0x0a,0x09,0x09,0x09,0x09,0x7f,0x49,0x49,0x49,0x49,0x49,0x41,0x41,
0x00,0x00,0x00,0x00,0x00,0x20,0x54,0x54,0x54,0x54,0x54,0x38,0x54,0x54,0x54,0x54,
0x54,0x18,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0xae,0x44,0x64,0x54,0x54,0x4c,0x44,
0x3a,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x1c,0x22,0x51,0x49,0x49,0x45,0x22,0x1c,
0x00,0x00,0x00,0x00,0x48,0x48,0x3c,0x6a,0x49,0x49,0x49,0x42,0x40,0x00,0x00,0x00,
0x00,0x00,0x0a,0x55,0x55,0x55,0x55,0x55,0x28,0x00,0x00,0x00,0x00,0x40,0x60,0x10,
0x19,0x14,0x12,0x12,0x12,0x14,0x19,0x10,0x60,0x40,0x00,0x00,0x00,0x00,0x38,0x45,
0x44,0x44,0x44,0x45,0x38,0x00,0x00,0x00,0x00,0x40,0x60,0x10,0x18,0x16,0x15,0x15,
0x15,0x16,0x18,0x10,0x60,0x40,0x00,0x00,0x00,0x00,0x38,0x54,0x54,0x56,0x54,0x55,
0x18,0x00,0x00,0x00,0x00,0x20,0x50,0x55,0x54,0x54,0x54,0x39,0x40,0x40,0x00,0x00,
0x00,0x20,0x50,0x57,0x55,0x55,0x57,0x38,0x40,0x40,0x00,0x00,0x00,0x3c,0x40,0x41,
0x40,0x40,0x40,0x41,0x40,0x3c,0x40,0x00,0x00,0x40,0x3e,0x25,0x25,0x25,0x25,0x25,
0x25,0x02,0x18,0x00,0x00,0x00,0x00,0x20,0x50,0x55,0x54,0x56,0x54,0x38,0x40,0x40,
0x00,0x00,0x00,0x00,0x00,0x01,0x00,0x00,0x00,0x01,0x00,0x00,0x00,0x00,0x00,0x00,
0x38,0xd1,0xd1,0xd1,0xf1,0x44,0x44,0x00,0x00,0x00,0x38,0x54,0x55,0x54,0x56,0x54,
0x54,0x18,0x00,0x00,0x00,0x00,0x00,0x00,0xf9,0x00,0x00,0x00,0x00,0xb0,0x00,0xc8,
0xc5,0xc0,0xc0,0x00,0xa0,0x00,0x00,0x00,0x02,0x7c,0x05,0x05,0x05,0x04,0x06,0x06,
0x06,0x78,0x01,0x00,0x00,0x00,0x46,0x7c,0x45,0x05,0x09,0x10,0x22,0x42,0x46,0x7c,
0x45,0x00,0x00,0x00,0x00,0x00,0x00,0x02,0x05,0x05,0x05,0x02,0x00,0x00,0x00,0x00,
0x00,0x00,0x18,0x25,0x42,0x42,0x42,0x42,0x42,0x42,0x42,0x42,0x25,0x18,0x00,0x00,
0x00,0x04,0x3d,0x44,0x40,0x40,0x40,0x40,0x40,0x40,0x44,0x3d,0x04,0x00,0x00,0x00,
0x3c,0x40,0x41,0x40,0x42,0x40,0x40,0x40,0x3c,0x40,0x00,0x00,0x38,0x44,0x45,0x44,
0x46,0x44,0x44,0x44,0x38,0x00,0x00,0x00,0x49,0x48,0x7a,0x40,0x40,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x4f,0x00,0x00,0x00,0x00,0x07,0x00,
0x00,0x00,0x07,0x00,0x00,0x00,0x00,0x00,0x14,0x14,0x7f,0x14,0x14,0x14,0x14,0x7f,
0x14,0x14,0x00,0x00,0x00,0x00,0x24,0x2a,0x2a,0x7f,0x2a,0x2a,0x2a,0x10,0x00,0x00,
0x00,0x00,0x02,0x05,0x45,0x25,0x12,0x08,0x04,0x22,0x51,0x50,0x50,0x20,0x00,0x00,
0x00,0x00,0x30,0x4e,0x49,0x49,0x49,0x56,0x40,0x20,0x10,0x40,0x00,0x00,0x00,0x00,
0x04,0x02,0x01,0x00,0x00,0x00,0x00,0x1c,0x22,0x41,0x00,0x00,0x00,0x41,0x22,0x1c,
0x00,0x00,0x00,0x00,0x08,0x08,0x2a,0x14,0x14,0x14,0x2a,0x08,0x08,0x00,0x00,0x00,
0x08,0x08,0x08,0x08,0x3e,0x08,0x08,0x08,0x08,0x00,0x00,0x00,0x00,0xa8,0x70,0x20,
0x00,0x00,0x00,0x08,0x08,0x08,0x08,0x08,0x08,0x08,0x08,0x08,0x00,0x00,0x00,0x00,
0x60,0x60,0x60,0x00,0x00,0x00,0x00,0x40,0x20,0x10,0x08,0x04,0x02,0x01,0x00,0x00,
0x00,0x00,0x1c,0x22,0x41,0x41,0x41,0x41,0x22,0x1c,0x00,0x00,0x00,0x00,0x00,0x00,
0x44,0x42,0x7f,0x40,0x40,0x00,0x00,0x00,0x00,0x00,0x42,0x61,0x41,0x51,0x41,0x49,
0x41,0x46,0x00,0x00,0x00,0x00,0x22,0x41,0x49,0x49,0x49,0x49,0x49,0x36,0x00,0x00,
0x00,0x00,0x10,0x18,0x14,0x12,0x11,0x11,0x7f,0x10,0x10,0x00,0x00,0x00,0x27,0x45,
0x45,0x45,0x45,0x45,0x29,0x11,0x00,0x00,0x00,0x00,0x30,0x48,0x4c,0x48,0x4a,0x49,
0x49,0x30,0x00,0x00,0x00,0x00,0x01,0x01,0x01,0x61,0x11,0x09,0x05,0x03,0x00,0x00,
0x00,0x00,0x36,0x00,0x49,0x49,0x49,0x49,0x00,0x36,0x00,0x00,0x00,0x00,0x06,0x09,
0x09,0x49,0x29,0x19,0x09,0x06,0x00,0x00,0x00,0x00,0x00,0x24,0x24,0x00,0x00,0x00,
0x00,0x00,0xa9,0x64,0x00,0x00,0x00,0x00,0x08,0x00,0x14,0x00,0x22,0x00,0x41,0x00,
0x00,0x00,0x00,0x00,0x14,0x14,0x14,0x14,0x14,0x14,0x14,0x14,0x00,0x00,0x00,0x00,
0x00,0x41,0x00,0x22,0x00,0x14,0x00,0x08,0x00,0x00,0x00,0x00,0x02,0x00,0x01,0x01,
0x51,0x09,0x00,0x06,0x00,0x00,0x00,0x00,0x00,0x04,0x02,0x31,0x41,0x49,0x49,0x79,
0x41,0x41,0x42,0x3c,0x00,0x00,0x40,0x60,0x10,0x18,0x14,0x12,0x11,0x12,0x14,0x18,
0x10,0x60,0x40,0x00,0x00,0x00,0x41,0x41,0x7f,0x49,0x49,0x49,0x49,0x49,0x49,0x49,
0x49,0x36,0x00,0x00,0x00,0x1c,0x22,0x41,0x41,0x41,0x41,0x41,0x41,0x41,0x41,0x22,
0x00,0x00,0x00,0x41,0x41,0x7f,0x41,0x41,0x41,0x41,0x41,0x41,0x41,0x22,0x1c,0x00,
0x00,0x00,0x7f,0x49,0x49,0x49,0x49,0x49,0x5d,0x41,0x41,0x63,0x00,0x00,0x00,0x00,
0x00,0x00,0x41,0x7f,0x49,0x09,0x09,0x09,0x1d,0x01,0x01,0x03,0x00,0x00,0x00,0x00,
0x1c,0x22,0x41,0x41,0x41,0x41,0x41,0x49,0x49,0x7a,0x08,0x08,0x00,0x00,0x41,0x7f,
0x49,0x08,0x08,0x08,0x08,0x08,0x08,0x49,0x7f,0x41,0x00,0x00,0x00,0x41,0x41,0x7f,
0x41,0x41,0x00,0x00,0x00,0x00,0x00,0x30,0x40,0x40,0x40,0x41,0x41,0x3f,0x01,0x01,
0x00,0x00,0x00,0x41,0x7f,0x49,0x08,0x08,0x10,0x24,0x43,0x41,0x01,0x00,0x00,0x01,
0x7f,0x41,0x40,0x40,0x40,0x40,0x40,0x40,0x40,0x00,0x00,0x00,0x00,0x41,0x7f,0x42,
0x04,0x08,0x10,0x08,0x04,0x42,0x7f,0x41,0x00,0x00,0x00,0x00,0x00,0x00,0x41,0x7f,
0x41,0x02,0x04,0x08,0x10,0x20,0x41,0x7f,0x41,0x00,0x00,0x00,0x00,0x1c,0x22,0x41,
0x41,0x41,0x41,0x41,0x41,0x41,0x41,0x22,0x1c,0x00,0x00,0x00,0x41,0x7f,0x49,0x09,
0x09,0x09,0x09,0x09,0x09,0x06,0x00,0x00,0x00,0x1c,0x22,0x41,0x41,0x41,0x41,0x51,
0x51,0x51,0x51,0x22,0x1c,0x40,0x40,0x00,0x00,0x41,0x7f,0x49,0x09,0x09,0x09,0x09,
0x09,0x19,0x29,0x4e,0x00,0x00,0x00,0x00,0x26,0x49,0x49,0x49,0x49,0x49,0x49,0x49,
0x32,0x00,0x00,0x00,0x03,0x01,0x01,0x01,0x41,0x7f,0x41,0x01,0x01,0x01,0x03,0x00,
0x00,0x00,0x01,0x3f,0x41,0x40,0x40,0x40,0x40,0x40,0x40,0x41,0x3f,0x01,0x00,0x00,
0x00,0x00,0x01,0x03,0x04,0x08,0x10,0x20,0x40,0x20,0x10,0x08,0x04,0x03,0x01,0x00,
0x00,0x01,0x0f,0x11,0x20,0x40,0x20,0x10,0x08,0x10,0x20,0x40,0x20,0x11,0x0f,0x01,
0x00,0x00,0x41,0x41,0x22,0x14,0x08,0x14,0x22,0x41,0x41,0x00,0x00,0x01,0x01,0x03,
0x04,0x48,0x70,0x48,0x04,0x03,0x01,0x01,0x00,0x00,0x00,0x00,0x43,0x61,0x51,0x49,
0x45,0x43,0x61,0x00,0x00,0x00,0x00,0x00,0x7f,0x41,0x41,0x41,0x41,0x41,0x00,0x00,
0x00,0x00,0x00,0x01,0x02,0x04,0x08,0x10,0x20,0x40,0x00,0x00,0x00,0x00,0x00,0x00,
0x41,0x41,0x41,0x41,0x41,0x7f,0x00,0x00,0x00,0x00,0x00,0x00,0x02,0x00,0x01,0x00,
0x02,0x00,0x00,0x00,0x00,0xc0,0xc0,0xc0,0xc0,0xc0,0xc0,0xc0,0xc0,0xc0,0xc0,0xc0,
0xc0,0xc0,0xc0,0xc0,0xc0,0xc0,0x00,0x00,0x01,0x02,0x04,0x00,0x00,0x00,0x20,0x50,
0x54,0x54,0x54,0x54,0x38,0x40,0x40,0x00,0x00,0x00,0x7f,0x44,0x44,0x44,0x44,0x44,
0x44,0x38,0x00,0x00,0x00,0x00,0x38,0x44,0x44,0x44,0x44,0x44,0x44,0x00,0x00,0x00,
0x38,0x44,0x44,0x44,0x44,0x44,0x44,0x7f,0x00,0x00,0x00,0x00,0x38,0x54,0x54,0x54,
0x54,0x54,0x54,0x18,0x00,0x00,0x00,0x00,0x08,0x08,0x08,0x7e,0x09,0x09,0x09,0x00,
0x00,0x00,0x38,0xd1,0xd1,0xd1,0xd1,0xd1,0xd1,0xbf,0x00,0x00,0x00,0x00,0x7f,0x04,
0x04,0x04,0x04,0x04,0x04,0x78,0x00,0x00,0x00,0x00,0x44,0x44,0x7d,0x40,0x40,0x00,
0x00,0x00,0x40,0xa0,0xa0,0xa0,0x7d,0x00,0x00,0x7f,0x10,0x10,0x10,0x08,0x14,0x20,
0x40,0x00,0x00,0x41,0x41,0x7f,0x40,0x40,0x00,0x00,0x00,0x00,0x7c,0x04,0x04,0x04,
0x04,0x7c,0x04,0x04,0x04,0x04,0x78,0x00,0x00,0x00,0x00,0x7c,0x04,0x04,0x04,0x04,
0x04,0x04,0x04,0x78,0x00,0x00,0x00,0x38,0x44,0x44,0x44,0x44,0x44,0x44,0x44,0x38,
0x00,0x00,0x00,0xff,0x44,0x44,0x44,0x44,0x44,0x44,0x44,0x38,0x00,0x00,0x00,0x38,
0x44,0x44,0x44,0x44,0x44,0x44,0x44,0xff,0x00,0x00,0x00,0x7c,0x04,0x04,0x04,0x04,
0x04,0x08,0x00,0x00,0x00,0x08,0x54,0x54,0x54,0x54,0x54,0x54,0x54,0x20,0x00,0x00,
0x00,0x04,0x04,0x04,0x3f,0x44,0x44,0x44,0x00,0x00,0x00,0x3c,0x40,0x40,0x40,0x40,
0x40,0x40,0x40,0x7c,0x00,0x00,0x00,0x04,0x08,0x10,0x20,0x40,0x20,0x10,0x08,0x04,
0x00,0x00,0x00,0x0c,0x10,0x20,0x40,0x20,0x10,0x08,0x10,0x20,0x40,0x20,0x10,0x0c,
0x00,0x00,0x00,0x44,0x28,0x00,0x10,0x00,0x28,0x44,0x00,0x00,0x00,0x00,0x00,0x04,
0xc2,0xa4,0x40,0x20,0x10,0x08,0x04,0x00,0x00,0x00,0x00,0x44,0x64,0x44,0x54,0x44,
0x4c,0x44,0x00,0x00,0x00,0x08,0x00,0x36,0x41,0x41,0x41,0x00,0x00,0x00,0x00,0x00,
0x7f,0x00,0x00,0x00,0x00,0x00,0x41,0x41,0x41,0x36,0x00,0x08,0x00,0x00,0x00,0x02,
0x00,0x01,0x01,0x01,0x00,0x02,0x02,0x02,0x00,0x01,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,
])

//offset=5f07; width=16; height=16 bytes; file=imagewriterii.bin
// data is over/under interleaved
export const NLQFixedFontData = new Uint8Array([
0x00,0x00,0x00,0x40,0x78,0x7c,0x0c,0x40,0x08,0x02,0x0a,0x00,0x08,0x01,0x09,0x00,
0x7f,0x7f,0x09,0x40,0x09,0x40,0x09,0x40,0x1d,0x4c,0x41,0x41,0x00,0x00,0x00,0x00,
0x00,0x00,0x20,0x20,0x44,0x10,0x14,0x40,0x14,0x40,0x14,0x40,0x50,0x04,0x78,0x3c,
0x50,0x04,0x14,0x40,0x14,0x40,0x14,0x40,0x10,0x44,0x58,0x0c,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x38,0xae,0xb2,0x24,0x40,0x44,0x04,0x60,0x24,0x40,0x14,0x50,
0x04,0x48,0x0c,0x40,0x44,0x04,0x48,0x26,0x3a,0x38,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x3e,0x3e,0x42,0x21,0x60,0x01,0x01,0x50,0x11,0x48,0x09,0x44,
0x05,0x40,0x40,0x03,0x42,0x21,0x3e,0x3e,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x40,0x00,0x00,0x60,0x08,0x60,0x48,0x20,0x3e,0x3f,0x48,0x01,
0x49,0x00,0x09,0x40,0x08,0x41,0x0a,0x41,0x00,0x40,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x4a,0x2f,0x40,0x0f,0x15,0x40,0x15,0x40,0x15,0x40,0x15,0x40,
0x15,0x40,0x15,0x40,0x40,0x1d,0x6a,0x3d,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x40,0x61,0x61,0x11,0x51,0x08,0x18,0x04,0x14,0x02,0x12,0x00,0x11,
0x02,0x12,0x04,0x14,0x08,0x18,0x11,0x51,0x61,0x61,0x00,0x40,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x38,0x38,0x48,0x24,0x41,0x05,0x05,0x41,0x04,0x40,0x04,0x40,
0x04,0x40,0x05,0x41,0x41,0x05,0x48,0x24,0x38,0x38,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x40,0x60,0x70,0x30,0x40,0x20,0x08,0x2a,0x03,0x25,0x04,0x25,0x00,
0x25,0x04,0x2a,0x03,0x20,0x08,0x30,0x40,0x60,0x70,0x00,0x40,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x38,0x38,0x58,0x24,0x50,0x04,0x14,0x40,0x14,0x40,0x16,0x40,
0x14,0x41,0x15,0x40,0x50,0x04,0x58,0x04,0x18,0x08,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x60,0x30,0x41,0x11,0x15,0x41,0x14,0x40,0x14,0x40,0x14,0x40,
0x14,0x40,0x50,0x04,0x59,0x25,0x79,0x39,0x00,0x40,0x00,0x40,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x60,0x30,0x40,0x10,0x10,0x44,0x12,0x47,0x15,0x44,0x15,0x44,
0x15,0x44,0x52,0x07,0x58,0x24,0x78,0x38,0x00,0x40,0x00,0x40,0x00,0x00,0x00,0x00,
0x00,0x00,0x04,0x00,0x3c,0x3c,0x41,0x21,0x41,0x01,0x00,0x40,0x00,0x40,0x00,0x40,
0x00,0x40,0x41,0x01,0x41,0x21,0x7c,0x3c,0x00,0x40,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x40,0x40,0x00,0x3e,0x3f,0x04,0x21,0x05,0x20,0x05,0x20,
0x05,0x20,0x05,0x20,0x05,0x24,0x28,0x07,0x2a,0x03,0x10,0x18,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x60,0x30,0x40,0x10,0x14,0x40,0x15,0x40,0x14,0x41,0x16,0x40,
0x14,0x40,0x50,0x04,0x58,0x24,0x78,0x38,0x00,0x40,0x00,0x40,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x01,0x01,0x01,0x01,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x01,0x01,0x01,0x01,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x38,0x18,0xca,0x24,0xc0,0x24,0xd1,0x00,0xd1,0x00,0xd1,0x00,
0xb1,0xb0,0x44,0x00,0x44,0x00,0x00,0x24,0x28,0x24,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x38,0x38,0x58,0x24,0x50,0x04,0x14,0x40,0x15,0x40,0x14,0x41,
0x16,0x40,0x14,0x40,0x50,0x04,0x58,0x04,0x18,0x08,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x04,0xfb,0xbd,
0x00,0x04,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0xb0,0x40,0xb0,0xa8,0x00,0xa8,0xc8,0x00,0xc9,0x00,0xc5,0x16,
0xc1,0x00,0xc0,0x00,0x00,0xa0,0xa0,0xa0,0xa0,0x40,0x00,0x00,0x00,0x00,0x00,0x00,
0x02,0x00,0x00,0x01,0x05,0x40,0x7d,0x7c,0x01,0x44,0x04,0x01,0x04,0x01,0x04,0x01,
0x06,0x00,0x06,0x00,0x06,0x00,0x00,0x45,0x79,0x7c,0x00,0x40,0x00,0x00,0x00,0x00,
0x02,0x00,0x04,0x41,0x7d,0x7c,0x05,0x44,0x0d,0x40,0x00,0x09,0x10,0x01,0x00,0x11,
0x22,0x00,0x06,0x60,0x46,0x40,0x7c,0x7d,0x05,0x40,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x02,0x03,0x05,0x00,0x05,0x00,
0x05,0x00,0x02,0x03,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x38,0x3c,0x45,0x25,0x45,0x01,0x00,0x42,0x00,0x42,0x00,0x42,0x00,0x42,
0x00,0x42,0x00,0x42,0x00,0x42,0x45,0x01,0x45,0x25,0x38,0x3c,0x00,0x00,0x00,0x00,
0x00,0x00,0x04,0x00,0x3d,0x3d,0x45,0x21,0x40,0x00,0x00,0x40,0x00,0x40,0x00,0x40,
0x00,0x40,0x40,0x00,0x45,0x21,0x3d,0x3d,0x04,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x04,0x00,0x3c,0x3c,0x40,0x20,0x40,0x00,0x01,0x40,0x00,0x41,0x02,0x40,
0x00,0x40,0x40,0x00,0x40,0x20,0x7c,0x3c,0x00,0x40,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x38,0x38,0x48,0x24,0x40,0x04,0x04,0x40,0x05,0x40,0x04,0x41,
0x06,0x40,0x04,0x40,0x40,0x04,0x48,0x24,0x38,0x38,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x40,0x01,0x44,0x00,0x45,0x7a,0x7c,
0x00,0x40,0x00,0x40,0x00,0x40,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x5f,0x4f,0x5f,0x4f,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x07,0x07,0x00,0x00,0x00,0x00,0x00,0x00,
0x07,0x07,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x04,0x10,0x04,0x10,0x04,0x10,0x7f,0x7f,0x04,0x10,0x04,0x10,
0x04,0x10,0x04,0x10,0x7f,0x7f,0x04,0x10,0x04,0x10,0x04,0x10,0x00,0x00,0x00,0x00,
0x00,0x00,0x04,0x10,0x20,0x06,0x2a,0x26,0x0a,0x20,0x0a,0x20,0x0a,0x20,0x7f,0x7f,
0x0a,0x20,0x0a,0x20,0x0a,0x20,0x2a,0x2a,0x20,0x0a,0x14,0x10,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x02,0x13,0x05,0x10,0x15,0x00,0x15,0x00,0x05,0x08,0x02,0x0b,
0x68,0x20,0x08,0x50,0x00,0x54,0x00,0x54,0x04,0x50,0x64,0x20,0x00,0x00,0x00,0x00,
0x00,0x00,0x30,0x30,0x42,0x0b,0x04,0x49,0x09,0x44,0x09,0x40,0x09,0x44,0x04,0x49,
0x52,0x03,0x40,0x10,0x20,0x20,0x00,0x20,0x60,0x00,0x00,0x50,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x04,0x04,0x00,0x00,0x02,0x02,0x00,
0x00,0x01,0x01,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x1c,0x1c,0x24,0x12,0x22,0x22,0x42,0x21,
0x40,0x01,0x01,0x40,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x01,0x40,0x40,0x01,0x42,0x21,
0x22,0x22,0x24,0x12,0x1c,0x1c,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x08,0x00,0x08,0x42,0x08,0x24,0x2a,0x18,0x1c,0x18,0x00,
0x18,0x00,0x18,0x1c,0x24,0x2a,0x42,0x08,0x00,0x08,0x00,0x08,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x08,0x00,0x08,0x00,0x08,0x00,0x08,0x00,0x08,0x7e,0x3e,
0x00,0x08,0x00,0x08,0x00,0x08,0x00,0x08,0x00,0x08,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0xd0,0x00,0x40,0xb8,
0xb0,0x60,0x40,0x40,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x08,0x00,0x08,0x00,0x08,0x00,0x08,0x00,0x08,0x00,0x08,
0x00,0x08,0x00,0x08,0x00,0x08,0x00,0x08,0x00,0x08,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x40,0x00,0x40,0x60,
0x40,0x60,0x40,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x40,0x40,0x00,0x00,0x20,0x20,0x00,0x00,0x10,0x10,0x00,0x00,0x08,0x08,0x00,
0x00,0x04,0x04,0x00,0x00,0x02,0x02,0x00,0x00,0x01,0x01,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x3e,0x3e,0x42,0x21,0x40,0x01,0x01,0x40,0x01,0x40,0x01,0x40,
0x01,0x40,0x40,0x01,0x42,0x21,0x3e,0x3e,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x42,0x02,0x40,0x00,0x41,0x7f,0x7f,
0x00,0x40,0x00,0x40,0x00,0x40,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x42,0x42,0x42,0x61,0x20,0x41,0x21,0x40,0x01,0x50,0x11,0x40,
0x11,0x40,0x01,0x48,0x09,0x40,0x08,0x41,0x02,0x45,0x46,0x62,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x22,0x22,0x02,0x20,0x40,0x01,0x40,0x01,0x09,0x40,0x09,0x40,
0x09,0x40,0x09,0x40,0x48,0x01,0x40,0x0d,0x02,0x2c,0x36,0x32,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x10,0x10,0x10,0x00,0x18,0x08,0x10,0x00,0x14,0x04,0x10,
0x00,0x12,0x02,0x50,0x00,0x51,0x7f,0x7f,0x00,0x50,0x00,0x50,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x2f,0x27,0x49,0x20,0x49,0x00,0x01,0x44,0x01,0x44,0x01,0x44,
0x01,0x44,0x01,0x44,0x01,0x44,0x49,0x00,0x49,0x28,0x31,0x38,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x3c,0x3c,0x54,0x2a,0x42,0x08,0x0a,0x40,0x08,0x41,0x08,0x41,
0x08,0x41,0x09,0x41,0x09,0x40,0x41,0x08,0x51,0x28,0x31,0x30,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x01,0x01,0x01,0x00,0x01,0x00,0x01,0x00,0x01,0x00,0x61,0x60,
0x11,0x18,0x09,0x00,0x01,0x04,0x05,0x00,0x01,0x02,0x03,0x01,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x36,0x32,0x56,0x2d,0x40,0x0d,0x09,0x40,0x09,0x40,0x09,0x40,
0x09,0x40,0x09,0x40,0x09,0x40,0x40,0x0d,0x56,0x2d,0x36,0x32,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x06,0x06,0x0a,0x05,0x08,0x01,0x01,0x08,0x01,0x48,0x41,0x08,
0x01,0x28,0x21,0x08,0x01,0x18,0x18,0x09,0x0a,0x0d,0x0e,0x06,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x24,0x6c,0x24,
0x6c,0x24,0x00,0x24,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0xa9,0xbb,0x24,
0x6c,0x64,0x40,0x24,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x08,0x18,0x00,0x18,0x00,0x00,0x14,0x24,0x00,
0x24,0x00,0x00,0x22,0x42,0x00,0x42,0x00,0x00,0x41,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x14,0x00,0x14,0x00,0x14,0x00,0x14,0x00,0x14,0x00,0x14,0x00,0x14,
0x00,0x14,0x00,0x14,0x00,0x14,0x00,0x14,0x00,0x14,0x00,0x14,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x41,0x42,0x00,0x42,0x00,0x00,0x22,0x24,0x00,
0x24,0x00,0x00,0x14,0x18,0x00,0x18,0x00,0x00,0x08,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x02,0x02,0x02,0x01,0x00,0x01,0x01,0x00,0x41,0x00,0x51,0x68,
0x49,0x00,0x09,0x00,0x00,0x05,0x06,0x05,0x06,0x02,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x06,0x06,0x02,0x01,0x70,0x31,0x11,0x40,0x01,0x48,0x01,0x48,
0x01,0x48,0x71,0x38,0x01,0x40,0x00,0x41,0x42,0x21,0x3e,0x3e,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x40,0x60,0x70,0x11,0x48,0x19,0x04,0x15,0x02,0x13,0x01,0x11,0x00,
0x13,0x01,0x14,0x02,0x18,0x04,0x10,0x48,0x60,0x70,0x00,0x40,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x01,0x40,0x01,0x40,0x7f,0x7f,0x09,0x40,0x09,0x40,0x09,0x40,
0x09,0x40,0x09,0x40,0x08,0x45,0x46,0x0d,0x56,0x2a,0x30,0x30,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x3c,0x1e,0x22,0x22,0x42,0x21,0x40,0x01,0x01,0x40,0x01,0x40,
0x01,0x40,0x01,0x40,0x01,0x40,0x40,0x01,0x42,0x21,0x23,0x23,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x01,0x40,0x01,0x40,0x7f,0x7f,0x01,0x40,0x01,0x40,0x01,0x40,
0x01,0x40,0x01,0x40,0x01,0x40,0x40,0x01,0x42,0x21,0x3e,0x3e,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x01,0x40,0x01,0x40,0x7f,0x7f,0x09,0x40,0x09,0x40,0x09,0x40,
0x09,0x40,0x1d,0x4c,0x01,0x40,0x01,0x40,0x01,0x40,0x63,0x63,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x01,0x40,0x01,0x40,0x7f,0x7f,0x09,0x40,0x09,0x40,0x09,0x40,
0x09,0x40,0x1d,0x0c,0x01,0x00,0x01,0x00,0x01,0x00,0x03,0x03,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x3c,0x1e,0x22,0x22,0x42,0x21,0x40,0x01,0x01,0x40,0x01,0x40,
0x01,0x40,0x01,0x48,0x01,0x48,0x40,0x09,0x42,0x29,0x33,0x3b,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x01,0x40,0x7f,0x7f,0x09,0x40,0x09,0x40,0x08,0x00,0x08,0x00,
0x08,0x00,0x08,0x00,0x09,0x40,0x09,0x40,0x7f,0x7f,0x01,0x40,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x01,0x40,0x01,0x40,0x01,0x40,0x7f,0x7f,
0x01,0x40,0x01,0x40,0x01,0x40,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x20,0x30,0x40,0x20,0x40,0x00,0x00,0x40,0x00,0x40,0x01,0x40,
0x01,0x40,0x41,0x00,0x41,0x20,0x3f,0x3f,0x01,0x00,0x01,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x01,0x40,0x01,0x40,0x7f,0x7f,0x01,0x48,0x09,0x48,0x10,0x04,
0x04,0x10,0x20,0x02,0x03,0x60,0x41,0x41,0x01,0x40,0x01,0x40,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x01,0x40,0x01,0x40,0x7f,0x7f,0x01,0x40,0x01,0x40,0x01,0x40,
0x01,0x40,0x00,0x40,0x00,0x40,0x00,0x40,0x00,0x40,0x60,0x60,0x00,0x00,0x00,0x00,
0x00,0x00,0x01,0x40,0x7f,0x7f,0x01,0x40,0x02,0x41,0x04,0x02,0x08,0x04,0x10,0x08,
0x08,0x04,0x04,0x02,0x02,0x41,0x01,0x40,0x7f,0x7f,0x01,0x40,0x00,0x00,0x00,0x00,
0x00,0x00,0x01,0x40,0x7f,0x7f,0x01,0x41,0x03,0x42,0x04,0x00,0x00,0x04,0x08,0x08,
0x10,0x00,0x00,0x10,0x21,0x60,0x41,0x40,0x7f,0x7f,0x01,0x40,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x3e,0x3e,0x42,0x21,0x40,0x01,0x01,0x40,0x01,0x40,0x01,0x40,
0x01,0x40,0x01,0x40,0x01,0x40,0x40,0x01,0x42,0x21,0x3e,0x3e,0x00,0x00,0x00,0x00,
0x00,0x00,0x01,0x40,0x01,0x40,0x7f,0x7f,0x01,0x48,0x01,0x48,0x01,0x48,0x01,0x48,
0x01,0x08,0x01,0x08,0x01,0x08,0x08,0x01,0x0a,0x05,0x06,0x06,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x3e,0x3e,0x42,0x21,0x40,0x01,0x01,0x40,0x01,0x40,0x01,0x40,
0x01,0x40,0x01,0x50,0x21,0x40,0x40,0x21,0x42,0x21,0x3e,0x5e,0x00,0x00,0x00,0x00,
0x00,0x00,0x01,0x40,0x01,0x40,0x7f,0x7f,0x01,0x48,0x01,0x48,0x01,0x08,0x11,0x08,
0x01,0x18,0x21,0x08,0x01,0x28,0x48,0x01,0x0a,0x45,0x06,0x46,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x66,0x62,0x42,0x25,0x40,0x05,0x09,0x40,0x09,0x40,0x09,0x40,
0x09,0x40,0x09,0x40,0x09,0x40,0x40,0x09,0x52,0x29,0x33,0x33,0x00,0x00,0x00,0x00,
0x00,0x00,0x03,0x03,0x01,0x00,0x01,0x00,0x01,0x40,0x01,0x40,0x01,0x40,0x7f,0x7f,
0x01,0x40,0x01,0x40,0x01,0x40,0x01,0x00,0x01,0x00,0x03,0x03,0x00,0x00,0x00,0x00,
0x00,0x00,0x01,0x00,0x3f,0x3f,0x41,0x20,0x41,0x00,0x00,0x40,0x00,0x40,0x00,0x40,
0x00,0x40,0x00,0x40,0x41,0x00,0x41,0x20,0x3f,0x3f,0x01,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x01,0x00,0x03,0x03,0x05,0x04,0x09,0x08,0x10,0x10,0x20,0x20,0x40,0x40,
0x20,0x20,0x10,0x10,0x09,0x08,0x05,0x04,0x03,0x03,0x01,0x00,0x00,0x00,0x00,0x00,
0x01,0x00,0x03,0x03,0x0d,0x04,0x31,0x18,0x40,0x60,0x20,0x30,0x18,0x08,0x04,0x04,
0x18,0x08,0x20,0x30,0x40,0x60,0x31,0x18,0x0d,0x04,0x03,0x03,0x01,0x00,0x00,0x00,
0x01,0x40,0x41,0x41,0x03,0x60,0x20,0x02,0x04,0x10,0x10,0x04,0x08,0x08,0x08,0x08,
0x10,0x04,0x04,0x10,0x20,0x02,0x03,0x60,0x41,0x41,0x01,0x40,0x00,0x00,0x00,0x00,
0x01,0x00,0x01,0x00,0x03,0x01,0x01,0x02,0x05,0x40,0x00,0x44,0x08,0x40,0x70,0x78,
0x08,0x40,0x00,0x44,0x05,0x40,0x01,0x02,0x03,0x01,0x01,0x00,0x01,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x43,0x41,0x21,0x60,0x01,0x50,0x11,0x40,0x01,0x48,0x09,0x40,
0x01,0x44,0x05,0x40,0x03,0x42,0x41,0x61,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x7f,0x7f,0x01,0x40,0x01,0x40,
0x01,0x40,0x01,0x40,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x01,0x00,0x00,0x01,0x02,0x00,0x00,0x02,0x04,0x00,0x00,0x04,0x08,0x00,0x00,0x08,
0x10,0x00,0x00,0x10,0x20,0x00,0x00,0x20,0x40,0x00,0x00,0x40,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x01,0x40,0x01,0x40,0x01,0x40,
0x01,0x40,0x7f,0x7f,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x02,0x02,0x00,0x00,0x01,0x01,0x00,
0x00,0x01,0x02,0x00,0x00,0x02,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0xc0,0x00,0xc0,0x00,0xc0,0x00,0xc0,0x00,0xc0,0x00,0xc0,0x00,0xc0,0x00,0xc0,0x00,
0xc0,0x00,0xc0,0x00,0xc0,0x00,0xc0,0x00,0xc0,0x00,0xc0,0x00,0xc0,0x00,0xc0,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x01,0x00,0x00,0x01,0x02,0x00,
0x00,0x02,0x04,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x20,0x20,0x40,0x10,0x14,0x40,0x14,0x40,0x14,0x40,0x14,0x40,
0x14,0x40,0x14,0x40,0x50,0x04,0x78,0x38,0x00,0x40,0x00,0x40,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x40,0x7f,0x7f,0x48,0x24,0x40,0x04,0x04,0x40,0x04,0x40,0x04,0x40,
0x04,0x40,0x04,0x40,0x04,0x40,0x40,0x04,0x48,0x24,0x38,0x38,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x38,0x38,0x48,0x24,0x40,0x04,0x04,0x40,0x04,0x40,0x04,0x40,
0x04,0x40,0x04,0x40,0x40,0x04,0x48,0x24,0x0c,0x24,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x38,0x38,0x48,0x24,0x40,0x04,0x04,0x40,0x04,0x40,0x04,0x40,
0x04,0x40,0x04,0x40,0x04,0x40,0x40,0x04,0x48,0x24,0x7f,0x7f,0x00,0x40,0x00,0x00,
0x00,0x00,0x00,0x00,0x38,0x38,0x58,0x24,0x50,0x04,0x14,0x40,0x14,0x40,0x14,0x40,
0x14,0x40,0x14,0x40,0x50,0x04,0x58,0x04,0x18,0x08,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x04,0x00,0x44,0x00,0x44,0x7e,0x7e,0x02,0x45,
0x00,0x45,0x01,0x44,0x01,0x44,0x01,0x04,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x38,0x18,0x28,0xa9,0x00,0xa9,0xd1,0x00,0xd1,0x00,0xd1,0x00,
0xd1,0x00,0xd1,0x00,0xd1,0x00,0x00,0xa9,0x28,0xa9,0xbe,0x7c,0x04,0x00,0x00,0x00,
0x00,0x00,0x01,0x40,0x7f,0x7f,0x08,0x4c,0x04,0x04,0x04,0x00,0x04,0x00,0x04,0x00,
0x04,0x00,0x04,0x04,0x08,0x44,0x78,0x78,0x00,0x40,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x40,0x05,0x41,0x7d,0x7d,
0x00,0x40,0x00,0x40,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0xa0,0x40,0xa0,0x00,0x00,0xa0,0x00,0xa0,0x00,0xa0,0x00,0xa0,
0xa0,0x01,0x7d,0x7d,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x7f,0x7f,0x10,0x00,0x10,0x00,0x00,0x18,0x00,0x18,0x28,0x00,
0x08,0x20,0x00,0x24,0x40,0x04,0x04,0x40,0x00,0x40,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x01,0x00,0x01,0x40,0x7f,0x7f,
0x00,0x40,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x04,0x40,0x7c,0x7c,0x00,0x44,0x04,0x00,0x04,0x00,0x04,0x00,0x04,0x40,0x78,0x7c,
0x04,0x40,0x04,0x00,0x04,0x00,0x04,0x00,0x04,0x40,0x78,0x7c,0x00,0x40,0x00,0x00,
0x00,0x00,0x00,0x00,0x04,0x40,0x7c,0x7c,0x00,0x44,0x04,0x00,0x04,0x00,0x04,0x00,
0x04,0x00,0x04,0x00,0x00,0x44,0x78,0x7c,0x00,0x40,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x38,0x38,0x48,0x24,0x40,0x04,0x04,0x40,0x04,0x40,0x04,0x40,
0x04,0x40,0x04,0x40,0x04,0x40,0x40,0x04,0x48,0x24,0x38,0x38,0x00,0x00,0x00,0x00,
0x00,0x00,0xc1,0x00,0xff,0xbf,0xca,0x24,0xc0,0x24,0xd1,0x00,0x44,0x00,0x44,0x00,
0x44,0x00,0x44,0x00,0x00,0x24,0x28,0x24,0x38,0x18,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x38,0x18,0x28,0x24,0x00,0x24,0x44,0x00,0x44,0x00,0x44,0x00,
0x44,0x00,0xd1,0x00,0xc0,0x24,0xca,0x24,0xff,0xbf,0xc1,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x04,0x40,0x78,0x7c,0x08,0x44,0x00,0x44,0x04,0x40,0x04,0x40,
0x04,0x00,0x04,0x00,0x04,0x00,0x04,0x00,0x00,0x04,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x48,0x2c,0x40,0x0c,0x14,0x40,0x14,0x40,0x14,0x40,0x14,0x40,
0x14,0x40,0x14,0x40,0x14,0x40,0x14,0x40,0x40,0x14,0x6c,0x34,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x04,0x00,0x04,0x00,0x3f,0x3f,0x44,0x20,0x44,0x00,
0x04,0x40,0x04,0x40,0x04,0x40,0x40,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x04,0x00,0x3c,0x3c,0x40,0x20,0x40,0x00,0x00,0x40,0x00,0x40,0x00,0x40,
0x00,0x40,0x40,0x00,0x40,0x20,0x7c,0x3c,0x00,0x40,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x04,0x00,0x0c,0x04,0x14,0x08,0x20,0x10,0x40,0x20,0x00,0x40,
0x40,0x20,0x20,0x10,0x14,0x08,0x0c,0x04,0x04,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x04,0x00,0x0c,0x0c,0x14,0x10,0x24,0x20,0x40,0x40,0x00,0x20,0x20,0x00,0x10,0x10,
0x20,0x00,0x00,0x20,0x40,0x40,0x24,0x20,0x14,0x10,0x0c,0x0c,0x04,0x00,0x00,0x00,
0x00,0x00,0x04,0x40,0x04,0x40,0x44,0x44,0x08,0x20,0x20,0x08,0x10,0x10,0x10,0x10,
0x20,0x08,0x08,0x20,0x44,0x44,0x04,0x40,0x04,0x40,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x04,0x00,0xc3,0x04,0xc5,0x08,0xc0,0xa4,0xe8,0x60,0xd0,0x00,
0x20,0x20,0x00,0x10,0x14,0x08,0x0c,0x04,0x04,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x0c,0x44,0x44,0x40,0x04,0x60,0x24,0x40,0x04,0x50,0x14,0x40,
0x04,0x48,0x0c,0x40,0x04,0x44,0x44,0x60,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x08,0x00,0x08,0x00,0x36,0x3e,0x42,0x21,
0x40,0x01,0x01,0x40,0x01,0x40,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x7f,0x7f,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x01,0x40,0x01,0x40,0x40,0x01,0x42,0x21,
0x36,0x3e,0x08,0x00,0x08,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x02,0x00,0x00,0x01,0x01,0x00,0x01,0x00,0x01,0x00,0x00,0x01,0x00,0x01,0x00,0x01,
0x02,0x00,0x02,0x00,0x02,0x00,0x00,0x01,0x01,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x38,0x18,0x78,0x3c,0xfc,0x7c,0xfc,0x7c,0xfc,0x7c,0x78,0x7c,0x7a,0x78,0x78,0x7d,
0xfd,0x7c,0xfc,0x7c,0xfc,0x7c,0x48,0x6c,0x48,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x38,0x18,0x40,0x24,0x84,0x40,0x84,0x00,0x84,0x00,0x00,0x44,0x02,0x44,0x00,0x45,
0x85,0x00,0x84,0x00,0xb4,0x10,0x00,0x6c,0x48,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0xfc,0x7c,0x78,0x3c,0x38,0x38,0x30,0x18,0x10,0x10,0x00,0x10,
0x20,0x00,0x00,0x20,0x40,0x00,0x00,0x40,0x80,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x81,0x00,0x81,0x41,0xc3,0x00,0x81,0x22,0xa5,0x00,0x81,0x14,0xd9,0x08,
0x81,0x14,0xa5,0x00,0x81,0x22,0xc3,0x00,0x81,0x41,0x81,0x00,0x00,0x00,0x00,0x00,
0x08,0x00,0x00,0x08,0x10,0x00,0x00,0x10,0x20,0x20,0x00,0x10,0x10,0x00,0x00,0x08,
0x08,0x00,0x00,0x04,0x04,0x00,0x00,0x02,0x02,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x08,0x00,0x00,0x08,0x10,0x00,0x00,0x10,0x20,0x20,0x00,0x10,0x10,0x00,0x00,0x08,
0x08,0x00,0x00,0x04,0x04,0x00,0x00,0x02,0x02,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x20,0x00,0x20,0x30,0x70,0x30,0x70,0x78,0xf8,0x78,0x20,0x00,0x20,0x00,0x20,0x00,
0x20,0x00,0x20,0x00,0x20,0x00,0x20,0x00,0x3f,0x1f,0x00,0x00,0x00,0x00,0x00,0x00,
0x95,0x00,0x95,0x00,0x95,0x00,0x95,0x00,0x95,0x00,0x95,0x00,0x95,0x00,0x95,0x00,
0x95,0x00,0x95,0x00,0x95,0x00,0x95,0x00,0x95,0x00,0x95,0x00,0x95,0x00,0x95,0x00,
0x08,0x00,0x08,0x0c,0x1c,0x00,0x08,0x12,0x2a,0x00,0x08,0x21,0x49,0x00,0x08,0x00,
0x08,0x00,0x08,0x00,0x08,0x00,0x08,0x00,0x08,0x00,0x08,0x00,0x08,0x00,0x08,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x80,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x80,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x80,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x10,0x00,0x00,0x10,0x20,0x00,0x00,0x20,0x40,0x00,0x00,0x40,0xff,0x7f,0x00,0x40,
0x40,0x00,0x00,0x20,0x20,0x00,0x00,0x10,0x10,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x08,0x00,0x00,0x04,0x04,0x00,0x00,0x02,0x02,0x00,0x00,0x01,0xff,0x7f,0x00,0x01,
0x02,0x00,0x00,0x02,0x04,0x00,0x00,0x04,0x08,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x01,0x00,0x01,0x00,0x01,0x00,0x01,0x00,0x01,0x00,0x01,0x00,0x01,0x00,0x01,0x00,
0x01,0x00,0x01,0x00,0x01,0x00,0x01,0x00,0x01,0x00,0x01,0x00,0x01,0x00,0x01,0x00,
0x20,0x00,0x20,0x30,0x70,0x30,0x70,0x78,0xf8,0x78,0x20,0x00,0x20,0x00,0x20,0x00,
0x20,0x00,0x20,0x00,0x20,0x00,0x20,0x00,0x3f,0x1f,0x00,0x00,0x00,0x00,0x00,0x00,
0xff,0x7f,0xff,0x7f,0xff,0x7f,0xff,0x7f,0xff,0x7f,0xff,0x7f,0xff,0x7f,0xff,0x7f,
0xff,0x7f,0xff,0x7f,0xff,0x7f,0xff,0x7f,0xff,0x7f,0xff,0x7f,0x00,0x00,0x00,0x00,
0x81,0x00,0x81,0x00,0x89,0x00,0x88,0x0c,0x9c,0x0c,0x9c,0x1e,0xbe,0x1e,0x3e,0x3f,
0x7f,0x3f,0x08,0x00,0x88,0x00,0x88,0x00,0x88,0x00,0x80,0x00,0x81,0x00,0x81,0x00,
0x81,0x00,0x81,0x00,0x80,0x00,0x88,0x00,0x88,0x00,0x88,0x00,0x08,0x00,0x7f,0x3f,
0x3e,0x3f,0xbe,0x1e,0x9c,0x1e,0x9c,0x0c,0x88,0x0c,0x89,0x00,0x81,0x00,0x81,0x00,
0xc3,0x41,0x00,0x00,0x08,0x00,0x08,0x08,0x18,0x08,0x18,0x18,0x38,0x18,0x38,0x38,
0x7e,0x3e,0x38,0x38,0x38,0x18,0x18,0x18,0x18,0x08,0x08,0x08,0x08,0x00,0xc3,0x41,
0xc3,0x41,0x00,0x00,0x10,0x00,0x10,0x08,0x18,0x08,0x18,0x0c,0x1c,0x0c,0x1c,0x0e,
0x7e,0x3e,0x1c,0x0e,0x1c,0x0c,0x18,0x0c,0x18,0x08,0x10,0x08,0x10,0x00,0xc3,0x41,
0x08,0x00,0x08,0x00,0x08,0x00,0x08,0x00,0x08,0x00,0x08,0x00,0x08,0x00,0x08,0x00,
0x08,0x00,0x08,0x00,0x08,0x00,0x08,0x00,0x08,0x00,0x08,0x00,0x08,0x00,0x08,0x00,
0xff,0x7f,0x80,0x00,0x80,0x00,0x80,0x00,0x80,0x00,0x80,0x00,0x80,0x00,0x80,0x00,
0x80,0x00,0x80,0x00,0x80,0x00,0x80,0x00,0x80,0x00,0x80,0x00,0x80,0x00,0x80,0x00,
0x08,0x00,0x08,0x00,0x08,0x00,0x08,0x00,0x08,0x00,0x08,0x00,0x08,0x00,0x08,0x00,
0x49,0x00,0x08,0x21,0x2a,0x00,0x08,0x12,0x1c,0x00,0x08,0x0c,0x08,0x00,0x00,0x00,
0xaa,0x00,0x00,0x00,0x55,0x00,0x00,0x00,0xaa,0x00,0x00,0x00,0x55,0x00,0x00,0x00,
0xaa,0x00,0x00,0x00,0x55,0x00,0x00,0x00,0xaa,0x00,0x00,0x00,0x55,0x00,0x00,0x00,
0xaa,0x00,0x00,0x00,0x55,0x00,0x00,0x00,0xaa,0x00,0x00,0x00,0x55,0x00,0x00,0x00,
0xaa,0x00,0x00,0x00,0x55,0x00,0x00,0x00,0xaa,0x00,0x00,0x00,0x55,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x78,0x7c,0x00,0x44,0x04,0x46,0x00,0x42,
0x00,0x42,0x00,0x42,0x00,0x42,0x00,0x42,0x00,0x42,0x00,0x42,0x04,0x46,0x00,0x44,
0x00,0x44,0x00,0x44,0x00,0x44,0x00,0x44,0x00,0x44,0x00,0x44,0x00,0x44,0x00,0x44,
0x00,0x44,0x08,0x40,0x70,0x78,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0xff,0x7f,
0x00,0x00,0x00,0x08,0x18,0x08,0x18,0x1c,0x3c,0x1c,0x3c,0x3e,0x7e,0x3e,0x7e,0x7f,
0x7e,0x3e,0x3c,0x3e,0x3c,0x1c,0x18,0x1c,0x18,0x08,0x00,0x08,0x00,0x00,0x00,0x00,
0x81,0x00,0x81,0x00,0x81,0x00,0x81,0x00,0x81,0x00,0x81,0x00,0x81,0x00,0x81,0x00,
0x81,0x00,0x81,0x00,0x81,0x00,0x81,0x00,0x81,0x00,0x81,0x00,0x81,0x00,0x81,0x00,
0x00,0x00,0x00,0x14,0x00,0x14,0x00,0x14,0x00,0x14,0x66,0x77,0x00,0x00,0x00,0x00,
0x00,0x00,0x66,0x77,0x00,0x14,0x00,0x14,0x00,0x14,0x00,0x14,0x00,0x00,0x00,0x00,
0x81,0x00,0x81,0x00,0x81,0x00,0x81,0x00,0x99,0x08,0x99,0x08,0x99,0x08,0x81,0x00,
0x81,0x00,0x81,0x00,0x81,0x00,0xff,0x7f,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0xff,0x7f,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
])

export const NLQPropTable = [
{"width":18, "offset":0},
{"width":16, "offset":20},
{"width":11, "offset":40},
{"width":12, "offset":55},
{"width":13, "offset":67},
{"width":12, "offset":80},
{"width":16, "offset":92},
{"width":12, "offset":108},
{"width":16, "offset":120},
{"width":12, "offset":136},
{"width":12, "offset":148},
{"width":12, "offset":160},
{"width":12, "offset":172},
{"width":14, "offset":184},
{"width":12, "offset":198},
{"width":13, "offset":210},
{"width":10, "offset":223},
{"width":12, "offset":233},
{"width":7, "offset":245},
{"width":12, "offset":252},
{"width":12, "offset":264},
{"width":16, "offset":276},
{"width":13, "offset":292},
{"width":15, "offset":305},
{"width":15, "offset":320},
{"width":12, "offset":335},
{"width":12, "offset":347},
{"width":8, "offset":359},
{"width":7, "offset":367},
{"width":7, "offset":374},
{"width":10, "offset":381},
{"width":14, "offset":391},
{"width":12, "offset":405},
{"width":16, "offset":417},
{"width":13, "offset":433},
{"width":7, "offset":446},
{"width":7, "offset":453},
{"width":7, "offset":460},
{"width":12, "offset":467},
{"width":12, "offset":479},
{"width":7, "offset":491},
{"width":12, "offset":498},
{"width":7, "offset":510},
{"width":12, "offset":517},
{"width":12, "offset":529},
{"width":12, "offset":541},
{"width":12, "offset":553},
{"width":12, "offset":565},
{"width":12, "offset":577},
{"width":12, "offset":589},
{"width":12, "offset":601},
{"width":12, "offset":613},
{"width":12, "offset":625},
{"width":12, "offset":637},
{"width":7, "offset":649},
{"width":7, "offset":656},
{"width":12, "offset":663},
{"width":12, "offset":675},
{"width":12, "offset":687},
{"width":12, "offset":699},
{"width":14, "offset":711},
{"width":16, "offset":725},
{"width":15, "offset":741},
{"width":14, "offset":756},
{"width":15, "offset":770},
{"width":15, "offset":785},
{"width":15, "offset":800},
{"width":14, "offset":815},
{"width":15, "offset":829},
{"width":9, "offset":844},
{"width":13, "offset":853},
{"width":12, "offset":866},
{"width":13, "offset":878},
{"width":17, "offset":891},
{"width":16, "offset":908},
{"width":15, "offset":924},
{"width":13, "offset":939},
{"width":16, "offset":952},
{"width":15, "offset":968},
{"width":12, "offset":983},
{"width":14, "offset":995},
{"width":15, "offset":1009},
{"width":16, "offset":1024},
{"width":17, "offset":1040},
{"width":11, "offset":1057},
{"width":14, "offset":1068},
{"width":11, "offset":1082},
{"width":12, "offset":1093},
{"width":12, "offset":1105},
{"width":12, "offset":1117},
{"width":12, "offset":1129},
{"width":17, "offset":1141},
{"width":7, "offset":1158},
{"width":12, "offset":1165},
{"width":12, "offset":1177},
{"width":10, "offset":1189},
{"width":12, "offset":1199},
{"width":12, "offset":1211},
{"width":10, "offset":1223},
{"width":12, "offset":1233},
{"width":12, "offset":1245},
{"width":8, "offset":1257},
{"width":7, "offset":1265},
{"width":10, "offset":1272},
{"width":8, "offset":1282},
{"width":16, "offset":1290},
{"width":12, "offset":1306},
{"width":12, "offset":1318},
{"width":12, "offset":1330},
{"width":12, "offset":1342},
{"width":10, "offset":1354},
{"width":12, "offset":1364},
{"width":10, "offset":1376},
{"width":12, "offset":1386},
{"width":12, "offset":1398},
{"width":16, "offset":1410},
{"width":12, "offset":1426},
{"width":12, "offset":1438},
{"width":10, "offset":1450},
{"width":10, "offset":1460},
{"width":7, "offset":1470},
{"width":10, "offset":1477},
{"width":13, "offset":1487},
{"width":7, "offset":1500},
]

//offset=73fb; width=16; height=16 bytes; file=imagewriterii.bin
// data is over/under interleaved
export const NLQPropFontData = new Uint8Array([
0x00,0x00,0x00,0x40,0x78,0x78,0x08,0x44,0x0c,0x00,0x08,0x02,0x0a,0x00,0x08,0x01,
0x09,0x00,0x7f,0x7f,0x09,0x40,0x09,0x40,0x09,0x40,0x1d,0x4c,0x01,0x40,0x43,0x61,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x60,0x30,0x44,0x10,0x14,0x40,
0x14,0x40,0x14,0x40,0x50,0x04,0x78,0x3c,0x50,0x04,0x14,0x40,0x14,0x40,0x14,0x40,
0x50,0x04,0x58,0x0c,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0xae,0x78,0x40,0x04,0x04,0x60,0x24,0x50,0x14,0x48,0x0c,0x40,0x40,0x04,
0x3c,0x3a,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x3e,0x3e,0x60,0x01,0x11,0x50,0x01,0x48,0x09,0x44,0x05,0x40,0x40,0x03,0x3e,0x3e,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x40,0x00,0x08,0x60,0x08,0x60,0x7e,0x3f,
0x09,0x20,0x49,0x00,0x49,0x00,0x0a,0x41,0x00,0x40,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x0a,0x20,0x40,0x0f,0x15,0x40,0x15,0x40,0x15,0x40,0x40,0x1d,
0x2a,0x20,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x40,0x40,0x60,0x21,0x51,
0x11,0x19,0x08,0x14,0x04,0x12,0x02,0x10,0x04,0x12,0x08,0x14,0x11,0x19,0x21,0x51,
0x40,0x60,0x00,0x40,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x79,0x3d,0x41,0x05,
0x04,0x40,0x04,0x40,0x04,0x40,0x41,0x05,0x79,0x3d,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x40,0x60,0x60,0x10,0x50,0x00,0x18,0x0a,0x17,0x05,0x10,0x05,0x10,
0x05,0x10,0x0a,0x17,0x00,0x18,0x10,0x50,0x60,0x60,0x00,0x40,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x78,0x3c,0x50,0x04,0x16,0x40,0x14,0x41,0x15,0x40,0x50,0x04,
0x58,0x0c,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x20,0x20,0x41,0x11,0x15,0x41,
0x14,0x40,0x14,0x40,0x14,0x40,0x51,0x05,0x79,0x39,0x00,0x40,0x00,0x00,0x00,0x00,
0x00,0x00,0x20,0x20,0x40,0x10,0x12,0x47,0x15,0x44,0x15,0x44,0x15,0x44,0x5a,0x03,
0x70,0x38,0x00,0x40,0x00,0x00,0x00,0x00,0x00,0x00,0x3c,0x3c,0x41,0x01,0x01,0x41,
0x00,0x40,0x00,0x40,0x00,0x40,0x01,0x41,0x41,0x01,0x7c,0x3c,0x00,0x40,0x00,0x00,
0x00,0x00,0x00,0x40,0x40,0x00,0x3e,0x3f,0x04,0x21,0x05,0x20,0x05,0x20,0x05,0x20,
0x20,0x07,0x2a,0x17,0x18,0x18,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x20,0x20,
0x40,0x10,0x14,0x40,0x15,0x40,0x14,0x41,0x16,0x40,0x50,0x04,0x78,0x38,0x00,0x40,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x01,0x01,0x01,0x01,0x00,0x00,
0x00,0x00,0x00,0x00,0x01,0x01,0x01,0x01,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0xce,0x3c,0xc0,0x24,0xd1,0x00,0xb1,0xb0,0x44,0x00,0x00,0x24,0x28,0x24,0x00,0x00,
0x00,0x00,0x00,0x00,0x78,0x3c,0x50,0x04,0x15,0x40,0x14,0x41,0x16,0x40,0x14,0x40,
0x50,0x04,0x58,0x0c,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x04,
0xfb,0xbd,0x00,0x04,0x00,0x00,0x00,0x00,0x00,0x00,0xb0,0x40,0x00,0xa8,0xc9,0x00,
0xc5,0x16,0xc1,0x00,0xc0,0x00,0x00,0xa0,0xa0,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x02,0x00,0x7c,0x7d,0x01,0x04,0x05,0x00,0x05,0x00,0x04,0x01,0x06,0x00,0x06,0x00,
0x02,0x04,0x78,0x7d,0x01,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x06,0x40,0x7c,0x7d,
0x05,0x44,0x09,0x00,0x01,0x08,0x10,0x01,0x02,0x10,0x22,0x00,0x06,0x60,0x7c,0x7d,
0x05,0x40,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x02,0x03,
0x05,0x00,0x05,0x00,0x05,0x00,0x02,0x03,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x38,0x3c,0x45,0x25,0x45,0x01,0x00,0x42,0x00,0x42,0x00,0x42,
0x00,0x42,0x00,0x42,0x00,0x42,0x45,0x01,0x45,0x25,0x38,0x3c,0x00,0x00,0x00,0x00,
0x00,0x00,0x04,0x00,0x3d,0x3d,0x45,0x21,0x40,0x00,0x00,0x40,0x00,0x40,0x00,0x40,
0x00,0x40,0x40,0x00,0x45,0x21,0x3d,0x3d,0x04,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x3c,0x3c,0x40,0x00,0x00,0x40,0x01,0x40,0x00,0x41,0x02,0x40,0x00,0x40,0x40,0x00,
0x7c,0x3c,0x00,0x40,0x00,0x00,0x00,0x00,0x78,0x3c,0x40,0x04,0x04,0x40,0x05,0x40,
0x04,0x41,0x06,0x40,0x04,0x40,0x40,0x04,0x78,0x3c,0x00,0x00,0x00,0x00,0x00,0x00,
0x01,0x44,0x00,0x45,0x7a,0x7c,0x00,0x40,0x00,0x40,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x40,0x00,0x4f,0x6f,0x40,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x07,0x07,0x00,0x00,
0x00,0x00,0x00,0x00,0x07,0x07,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x04,0x10,0x04,0x10,0x7f,0x7f,0x04,0x10,0x04,0x10,0x04,0x10,0x04,0x10,
0x7f,0x7f,0x04,0x10,0x04,0x10,0x00,0x00,0x00,0x00,0x00,0x00,0x24,0x06,0x20,0x06,
0x0a,0x20,0x0a,0x20,0x7f,0x7f,0x0a,0x20,0x0a,0x20,0x20,0x0a,0x30,0x1a,0x00,0x00,
0x00,0x00,0x00,0x00,0x42,0x03,0x05,0x20,0x25,0x00,0x05,0x10,0x12,0x03,0x00,0x08,
0x08,0x00,0x60,0x24,0x04,0x50,0x00,0x52,0x02,0x50,0x60,0x21,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x30,0x30,0x42,0x0b,0x0d,0x40,0x09,0x44,0x05,0x48,0x12,0x43,
0x40,0x10,0x20,0x20,0x50,0x10,0x00,0x40,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x04,0x04,0x02,0x02,0x01,0x01,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x1c,0x1c,
0x22,0x22,0x41,0x41,0x00,0x00,0x00,0x00,0x00,0x00,0x41,0x41,0x22,0x22,0x1c,0x1c,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x08,0x00,0x2a,0x00,0x08,0x12,0x14,0x0c,
0x14,0x00,0x14,0x0c,0x08,0x12,0x2a,0x00,0x08,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x08,0x00,0x08,0x00,0x08,0x00,0x08,0x00,0x3e,0x1e,0x08,0x00,0x08,0x00,0x08,0x00,
0x08,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0xd0,0x00,0x40,0xb8,0xb0,0x40,
0x00,0x00,0x00,0x00,0x00,0x00,0x08,0x00,0x08,0x00,0x08,0x00,0x08,0x00,0x08,0x00,
0x08,0x00,0x08,0x00,0x08,0x00,0x08,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x40,0x60,0x40,0x60,0x40,0x60,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x40,0x40,
0x20,0x20,0x10,0x10,0x08,0x08,0x04,0x04,0x02,0x02,0x01,0x01,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x3e,0x3e,0x40,0x01,0x01,0x40,0x01,0x40,0x01,0x40,0x01,0x40,
0x40,0x01,0x3e,0x3e,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x04,0x42,0x02,0x41,0x7f,0x7f,0x00,0x40,0x00,0x40,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x02,0x40,0x40,0x41,0x21,0x60,0x01,0x50,0x11,0x40,0x09,0x48,
0x00,0x45,0x06,0x42,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x02,0x20,0x40,0x01,
0x09,0x40,0x09,0x40,0x09,0x40,0x09,0x40,0x40,0x0d,0x36,0x32,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x10,0x10,0x08,0x18,0x04,0x14,0x02,0x12,0x00,0x51,0x01,0x50,
0x7f,0x7f,0x00,0x50,0x00,0x50,0x00,0x00,0x00,0x00,0x00,0x00,0x0f,0x27,0x49,0x00,
0x01,0x44,0x01,0x44,0x01,0x44,0x01,0x44,0x49,0x00,0x31,0x38,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x30,0x38,0x48,0x2c,0x4c,0x42,0x0a,0x40,0x0a,0x41,0x48,0x49,
0x51,0x28,0x31,0x30,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x01,0x01,0x01,0x00,
0x01,0x00,0x61,0x60,0x11,0x10,0x09,0x08,0x05,0x04,0x03,0x03,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x36,0x32,0x40,0x0d,0x09,0x40,0x09,0x40,0x09,0x40,0x09,0x40,
0x40,0x0d,0x36,0x32,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x06,0x06,0x0a,0x05,
0x09,0x09,0x01,0x48,0x41,0x28,0x21,0x19,0x1a,0x0d,0x0e,0x06,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x44,0x24,0x44,0x24,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x44,0xa9,0xb1,0x64,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x08,0x18,0x00,0x00,0x14,0x24,0x00,0x00,0x22,0x42,0x00,0x00,0x41,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x14,0x00,0x14,0x00,0x14,0x00,0x14,
0x00,0x14,0x00,0x14,0x00,0x14,0x00,0x14,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x41,0x42,0x00,0x00,0x22,0x24,0x00,0x00,0x14,0x18,0x00,0x00,0x08,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x02,0x00,0x00,0x01,0x01,0x00,0x41,0x00,
0x51,0x68,0x49,0x00,0x00,0x05,0x06,0x02,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x06,0x06,0x72,0x31,0x40,0x09,0x09,0x40,0x09,0x40,0x09,0x40,0x71,0x78,
0x01,0x40,0x00,0x41,0x42,0x01,0x7e,0x3e,0x00,0x00,0x00,0x00,0x00,0x40,0x60,0x60,
0x11,0x58,0x1d,0x04,0x13,0x02,0x11,0x01,0x11,0x00,0x11,0x01,0x12,0x02,0x1c,0x04,
0x10,0x58,0x60,0x60,0x00,0x40,0x00,0x00,0x00,0x00,0x00,0x00,0x01,0x40,0x01,0x40,
0x7f,0x7f,0x09,0x40,0x09,0x40,0x09,0x40,0x09,0x40,0x09,0x40,0x09,0x40,0x48,0x0d,
0x56,0x2d,0x36,0x32,0x00,0x00,0x00,0x00,0x00,0x00,0x3e,0x3e,0x42,0x21,0x40,0x01,
0x01,0x40,0x01,0x40,0x01,0x40,0x01,0x40,0x01,0x40,0x40,0x01,0x42,0x21,0x23,0x23,
0x00,0x00,0x00,0x00,0x00,0x00,0x01,0x40,0x01,0x40,0x7f,0x7f,0x01,0x40,0x01,0x40,
0x01,0x40,0x01,0x40,0x01,0x40,0x40,0x01,0x42,0x21,0x22,0x22,0x3c,0x1e,0x00,0x00,
0x00,0x00,0x00,0x00,0x01,0x40,0x7f,0x7f,0x09,0x40,0x09,0x40,0x09,0x40,0x09,0x40,
0x1d,0x4c,0x01,0x40,0x01,0x40,0x43,0x61,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x01,0x40,0x7f,0x7f,0x09,0x40,0x09,0x40,0x09,0x00,0x09,0x00,
0x1d,0x0c,0x01,0x00,0x01,0x00,0x03,0x01,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x3e,0x3e,0x42,0x21,0x40,0x01,0x01,0x40,0x01,0x40,0x01,0x40,0x01,0x40,0x01,0x48,
0x40,0x09,0x73,0x39,0x00,0x08,0x00,0x08,0x00,0x00,0x00,0x00,0x01,0x40,0x7f,0x7f,
0x09,0x40,0x08,0x00,0x08,0x00,0x08,0x00,0x08,0x00,0x08,0x00,0x08,0x00,0x09,0x40,
0x7f,0x7f,0x01,0x40,0x00,0x00,0x00,0x00,0x00,0x00,0x01,0x40,0x01,0x40,0x7f,0x7f,
0x01,0x40,0x01,0x40,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x60,0x30,
0x40,0x00,0x00,0x40,0x00,0x40,0x01,0x40,0x41,0x00,0x7f,0x3f,0x01,0x00,0x01,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x01,0x40,0x7f,0x7f,0x01,0x48,0x18,0x00,0x00,0x14,
0x24,0x00,0x00,0x62,0x43,0x40,0x01,0x41,0x01,0x40,0x00,0x00,0x00,0x00,0x01,0x00,
0x7f,0x7f,0x01,0x40,0x00,0x40,0x00,0x40,0x00,0x40,0x00,0x40,0x00,0x40,0x00,0x40,
0x60,0x60,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x01,0x40,0x7f,0x7f,0x02,0x41,
0x04,0x02,0x08,0x04,0x10,0x08,0x08,0x04,0x04,0x02,0x02,0x41,0x7f,0x7f,0x01,0x40,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x01,0x40,0x7f,0x7f,
0x00,0x41,0x02,0x02,0x04,0x04,0x08,0x08,0x10,0x10,0x20,0x20,0x41,0x00,0x7f,0x7f,
0x01,0x40,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x3e,0x3e,0x42,0x21,0x40,0x01,
0x01,0x40,0x01,0x40,0x01,0x40,0x01,0x40,0x01,0x40,0x01,0x40,0x40,0x01,0x42,0x21,
0x3e,0x3e,0x00,0x00,0x00,0x00,0x00,0x00,0x01,0x40,0x7f,0x7f,0x01,0x48,0x01,0x08,
0x01,0x08,0x01,0x08,0x01,0x08,0x08,0x01,0x0a,0x05,0x06,0x06,0x00,0x00,0x00,0x00,
0x00,0x00,0x3e,0x3e,0x42,0x21,0x40,0x01,0x01,0x40,0x01,0x40,0x01,0x50,0x01,0x50,
0x01,0x50,0x21,0x60,0x40,0x01,0x42,0x61,0x3e,0x7e,0x00,0x40,0x00,0x40,0x00,0x00,
0x00,0x00,0x01,0x40,0x7f,0x7f,0x01,0x48,0x01,0x08,0x01,0x08,0x01,0x08,0x11,0x18,
0x21,0x28,0x48,0x41,0x0a,0x45,0x06,0x46,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x66,0x62,0x46,0x25,0x40,0x05,0x09,0x40,0x09,0x40,0x09,0x40,0x40,0x09,0x52,0x29,
0x33,0x33,0x00,0x00,0x00,0x00,0x00,0x00,0x03,0x01,0x01,0x00,0x01,0x00,0x01,0x00,
0x01,0x40,0x7f,0x7f,0x01,0x40,0x01,0x00,0x01,0x00,0x01,0x00,0x03,0x01,0x00,0x00,
0x00,0x00,0x00,0x00,0x01,0x00,0x3f,0x3f,0x41,0x20,0x40,0x00,0x00,0x40,0x00,0x40,
0x00,0x40,0x00,0x40,0x40,0x00,0x41,0x20,0x3f,0x3f,0x01,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x01,0x00,0x03,0x03,0x05,0x04,0x08,0x08,0x10,0x10,0x20,0x20,
0x40,0x40,0x20,0x20,0x10,0x10,0x08,0x08,0x05,0x04,0x03,0x03,0x01,0x00,0x00,0x00,
0x00,0x00,0x01,0x00,0x07,0x03,0x09,0x0c,0x30,0x10,0x40,0x60,0x20,0x10,0x10,0x08,
0x08,0x04,0x10,0x08,0x20,0x10,0x40,0x60,0x30,0x10,0x09,0x0c,0x07,0x03,0x01,0x00,
0x00,0x00,0x00,0x00,0x01,0x40,0x41,0x41,0x22,0x22,0x14,0x14,0x08,0x08,0x14,0x14,
0x22,0x22,0x41,0x41,0x01,0x40,0x00,0x00,0x00,0x00,0x01,0x00,0x01,0x01,0x03,0x02,
0x04,0x04,0x08,0x48,0x70,0x70,0x08,0x48,0x04,0x04,0x03,0x02,0x01,0x01,0x01,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x43,0x41,0x21,0x60,0x11,0x50,0x09,0x48,
0x05,0x44,0x03,0x42,0x41,0x61,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x7f,0x7f,0x01,0x40,0x01,0x40,0x01,0x40,0x01,0x40,0x01,0x40,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x01,0x01,0x02,0x02,0x04,0x04,0x08,0x08,0x10,0x10,
0x20,0x20,0x40,0x40,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x01,0x40,0x01,0x40,0x01,0x40,0x01,0x40,0x01,0x40,0x7f,0x7f,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x02,0x00,0x00,0x01,0x01,0x00,0x00,0x01,
0x02,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0xc0,0x00,0xc0,0x00,0xc0,0x00,
0xc0,0x00,0xc0,0x00,0xc0,0x00,0xc0,0x00,0xc0,0x00,0xc0,0x00,0xc0,0x00,0xc0,0x00,
0xc0,0x00,0xc0,0x00,0xc0,0x00,0xc0,0x00,0xc0,0x00,0xc0,0x00,0x00,0x00,0x00,0x00,
0x01,0x01,0x02,0x02,0x04,0x04,0x00,0x00,0x00,0x00,0x00,0x00,0x60,0x30,0x40,0x10,
0x14,0x40,0x14,0x40,0x14,0x40,0x14,0x40,0x50,0x04,0x78,0x3c,0x00,0x40,0x00,0x00,
0x00,0x00,0x00,0x00,0x7f,0x7f,0x40,0x04,0x04,0x40,0x04,0x40,0x04,0x40,0x04,0x40,
0x40,0x04,0x78,0x3c,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x38,0x38,0x40,0x04,
0x04,0x40,0x04,0x40,0x04,0x40,0x40,0x04,0x48,0x24,0x00,0x00,0x00,0x00,0x00,0x00,
0x78,0x3c,0x40,0x04,0x04,0x40,0x04,0x40,0x04,0x40,0x04,0x40,0x40,0x04,0x7f,0x7f,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x78,0x3c,0x50,0x04,0x14,0x40,0x14,0x40,
0x14,0x40,0x14,0x40,0x50,0x04,0x58,0x0c,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x44,0x00,0x44,0x7e,0x7e,0x00,0x45,0x00,0x45,0x01,0x44,0x01,0x44,0x00,0x00,
0x00,0x00,0x00,0x00,0x38,0xa7,0x20,0xa1,0xc1,0x20,0xc1,0x20,0xc1,0x20,0x04,0xa8,
0xa8,0xa1,0xbf,0x7c,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x7f,0x7f,0x00,0x04,
0x04,0x00,0x04,0x00,0x04,0x00,0x04,0x00,0x00,0x04,0x78,0x7c,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x40,0x05,0x40,0x7c,0x7d,0x00,0x40,0x00,0x40,0x00,0x00,
0x00,0x00,0x00,0x00,0xa0,0x40,0x00,0xa0,0x00,0xa0,0x01,0xa0,0xbf,0x7d,0x00,0x00,
0x00,0x00,0x7f,0x7f,0x20,0x00,0x00,0x10,0x10,0x10,0x20,0x08,0x08,0x20,0x40,0x04,
0x04,0x40,0x00,0x00,0x00,0x00,0x01,0x40,0x01,0x40,0x7f,0x7f,0x00,0x40,0x00,0x40,
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x7c,0x7c,0x00,0x04,0x04,0x00,0x04,0x00,
0x00,0x04,0x78,0x7c,0x00,0x04,0x04,0x00,0x04,0x00,0x00,0x04,0x78,0x7c,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x7c,0x7c,0x00,0x04,0x04,0x00,0x04,0x00,0x04,0x00,
0x04,0x00,0x04,0x00,0x00,0x04,0x78,0x7c,0x00,0x00,0x00,0x00,0x00,0x00,0x78,0x3c,
0x40,0x04,0x04,0x40,0x04,0x40,0x04,0x40,0x04,0x40,0x04,0x40,0x40,0x04,0x78,0x3c,
0x00,0x00,0x00,0x00,0x00,0x00,0xff,0xbf,0x28,0x24,0x00,0x24,0x44,0x00,0x44,0x00,
0x44,0x00,0x00,0x24,0x28,0x24,0x38,0x18,0x00,0x00,0x00,0x00,0x00,0x00,0x38,0x18,
0x28,0x24,0x00,0x24,0x44,0x00,0x44,0x00,0x44,0x00,0x00,0x24,0x28,0x24,0xff,0xbf,
0x00,0x00,0x00,0x00,0x00,0x00,0x7c,0x7c,0x08,0x04,0x00,0x04,0x04,0x00,0x04,0x00,
0x04,0x00,0x00,0x04,0x00,0x00,0x00,0x00,0x00,0x00,0x48,0x6c,0x40,0x0c,0x14,0x40,
0x14,0x40,0x14,0x40,0x14,0x40,0x14,0x40,0x40,0x14,0x6c,0x34,0x00,0x00,0x00,0x00,
0x00,0x00,0x04,0x00,0x04,0x00,0x7e,0x3f,0x44,0x00,0x04,0x40,0x04,0x40,0x04,0x40,
0x00,0x00,0x00,0x00,0x00,0x00,0x7c,0x3c,0x40,0x00,0x00,0x40,0x00,0x40,0x00,0x40,
0x00,0x40,0x00,0x40,0x40,0x00,0x7c,0x7c,0x00,0x00,0x00,0x00,0x00,0x00,0x04,0x04,
0x0c,0x08,0x10,0x10,0x20,0x20,0x40,0x40,0x20,0x20,0x10,0x10,0x0c,0x08,0x04,0x04,
0x00,0x00,0x00,0x00,0x00,0x00,0x0c,0x0c,0x34,0x10,0x40,0x60,0x20,0x00,0x00,0x10,
0x10,0x00,0x00,0x08,0x10,0x00,0x00,0x10,0x20,0x00,0x40,0x60,0x34,0x10,0x0c,0x0c,
0x00,0x00,0x00,0x00,0x00,0x00,0x44,0x44,0x0c,0x60,0x20,0x08,0x10,0x10,0x20,0x08,
0x0c,0x60,0x44,0x44,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x04,0x04,
0xc3,0xa2,0xa4,0x50,0x60,0x20,0x20,0x20,0x10,0x10,0x0c,0x08,0x04,0x04,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,0x4c,0x44,0x04,0x60,0x24,0x40,0x14,0x50,0x04,0x48,
0x0c,0x40,0x44,0x64,0x00,0x00,0x00,0x00,0x00,0x00,0x08,0x00,0x08,0x00,0x76,0x3f,
0x01,0x40,0x01,0x40,0x01,0x40,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x7f,0x7f,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x01,0x40,0x01,0x40,
0x01,0x40,0x76,0x3f,0x08,0x00,0x08,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x02,0x00,
0x00,0x01,0x01,0x00,0x01,0x00,0x01,0x00,0x00,0x01,0x02,0x00,0x02,0x00,0x02,0x00,
0x00,0x01,0x01,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,
0x00,0x00,0x00,0x00,0x00,0x00,
])

export interface Font {
  width: number;
  height: number;
  scale: number;
  drawGlyph(code: number): void;
  data: Uint8Array;
  table: {width:number, offset:number} [];
}

export const DraftFont : Font = {
  width: 12,
  height: 8,
  scale: 8/12,
  drawGlyph: function (code) {
    const offset = code * this.width
    for(let i=0;i<this.width;i++)
      fontGfx(this.data[offset+i])
  },
  data: DraftFixedFontData,
  table: [],
}

export const CspFont : Font = {
  width: 8,
  height: 8,
  scale: 8/8,
  drawGlyph: function (code) {
    const offset = code * this.width
    for(let i=0;i<this.width;i++)
      fontGfx(this.data[offset+i])
  },
  data: CorrespondenceFixedFontData,
  table: [],
}

export const CspPropFont : Font = {
  width: 12,
  height: 8,
  scale: 1,
  drawGlyph: function (code) {
    const offset = this.table[code].offset
    const gwidth = this.table[code].width 
    for(let i=0;i<gwidth;i++)
      fontGfx(this.data[offset+i])
  },
  data: CorrespondencePropFontData,
  table: CorrespondencePropTable,
}

export const NLQFont : Font = {
  width: 16,
  height: 16,
  scale: 8/16,
  drawGlyph: function (code) {
    // data is over/under interleaved
    const offset = code * this.width * 2
    for(let i=0;i<this.width;i++) {
      fontGfx16(this.data[offset+i*2+0],
                this.data[offset+i*2+1])
    }
  },
  data: NLQFixedFontData,
  table: [],
}

export const NLQPropFont : Font = {
  width: 16,
  height: 16,
  scale: 1,
  drawGlyph: function (code) {
    // data is over/under interleaved, so multiply from table
    const offset = this.table[code].offset*2
    const gwidth = this.table[code].width 
    for(let i=0;i<gwidth;i++) {
      fontGfx16(this.data[offset+i*2+0],
                this.data[offset+i*2+1])
    }
  },
  data: NLQPropFontData,
  table: NLQPropTable,
}
